import { datasFases, sincronizarFasesContrato, ehFaseExecucao } from '../lib/fasesDatas';
import { LINHAS, LINHA_COR, LINHA_ICON } from '../constants/linhas';
import { CampoMencoes, notificarMencoes } from '../lib/mencoes';
import React, { useState, useEffect, useRef } from 'react';
import { segmentosRota, irPara, useAoVoltar } from '../lib/rota';
import BriefingModal from './BriefingModal';
import { AcoesDoProjeto, AcaoModal } from './FormacoesPage';
import { sincronizarFases, tarefaComercial } from '../lib/formacao';
import FichaAcolhimentoIP from './FichaAcolhimentoIP';
import FichaGIC from './FichaGIC';
import ClienteView from './ClienteView';
import { supabase } from '../supabase';
import { ehFollowup, criarFollowups } from '../lib/followups';
import PassagemPainel from '../components/PassagemPainel';
import { bloqueio, passagemAberta, iniciarPassagem, nomear } from '../lib/passagem';
import { ehEvento, eventoAtivo, sincronizarReceita } from '../lib/eventos';

const C = {
  purple:"#691FB1", purpleLight:"#EDE7F6",
  red:"#FF357B", redLight:"#FFF0F5",
  amber:"#F39C12", amberLight:"#FEF9E7",
  green:"#27AE60", greenLight:"#EAFAF1",
  blue:"#57B1DD", blueLight:"#E5F7FF",
  bg:"#F7F5FC", white:"#FFFFFF",
  text:"#1A1A2E", textMid:"#4A4A6A", textLight:"#8888AA",
  border:"#E4DEFA",
};

const PROJECT_TYPES  = ["Standard","GL","COPSOQ","WOW","Wellbeing Custom","Evento","Wellbeing Games","Wellbeing Awards","Formação","Incidentes IP - Fluxo B","GIC - Workwell"];
const BILLING_MODELS = ["Mensal fixo","Por sessão","Por marco","Único","Pré-pago"];
const BUSINESS_AREAS = LINHAS;
const SUBTASK_TYPES  = ["Reunião","Documento","Comunicação","Análise","Outro"];

const PROJECT_STATES = {
  "Em proposta": { color:"#57B1DD", bg:"#E5F7FF" },
  "Ativo":       { color:"#27AE60", bg:"#EAFAF1" },
  "Em pausa":    { color:"#F39C12", bg:"#FEF9E7" },
  "Concluído":   { color:"#691FB1", bg:"#EDE7F6" },
  "Cancelado":   { color:"#E74C3C", bg:"#FDEDEC" },
};

const PHASE_STATES = {
  "Por iniciar":    { color:"#8888AA", bg:"#F4F6F7" },
  "Em curso":       { color:"#57B1DD", bg:"#E5F7FF" },
  "Concluída":      { color:"#27AE60", bg:"#EAFAF1" },
  "Bloqueada":      { color:"#E74C3C", bg:"#FDEDEC" },
  "Não aplicável":  { color:"#BBBBBB", bg:"#F8F8F8" },
};

// tipos de projeto cujo modelo tinha follow-ups trimestrais (esses passam a tarefas do comercial)
export const temFollowups = (tipo) => !!(TEMPLATES[tipo] || []).some(t => ehFollowup(t.nome));
export const TEMPLATES = {
  "Standard": [
    { nome:"Planeamento interno",          dias:7,   subatividades:["Definição de objetivos","Alocação de equipa"] },
    { nome:"Alinhamento com cliente",      dias:7,   subatividades:["Reunião kickoff","Validação de datas e horas"] },
    { nome:"Alinhamento com profissional", dias:5,   subatividades:["Confirmar disponibilidade","Briefing ao profissional"] },
    { nome:"Execução",                     dias:90,  subatividades:["Acompanhamento operacional"] },
    { nome:"Acompanhamento e fecho",       dias:14,  subatividades:["Feedback cliente","Fecho administrativo"] },
    { nome:"Follow-up trimestral #1", dias:90, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste ou extensão","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #2", dias:180, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste ou extensão","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #3", dias:270, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste ou extensão","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #4", dias:360, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste ou extensão","Fechar ou renovar contrato"] },
  ],
  "GL": [
    { nome:"Planeamento e Diagnóstico",      dias:30,  subatividades:["Reunião de levantamento","Definição de objetivos","Escolha de protocolo","Aplicação de questionários","Visita diagnóstico","Planeamento de recursos"] },
    { nome:"Sensibilização e Comunicação",   dias:14,  subatividades:["Definição do cronograma","Comunicação interna","Envolvimento das lideranças","Sessão de sensibilização"] },
    { nome:"Implementação das Sessões",      dias:365, subatividades:["Registo de presenças","Feedback contínuo mensal"] },
    { nome:"Acompanhamento e Avaliação",     dias:30,  subatividades:["Revisões trimestrais","Reaplicação de questionários","Relatório final"] },
    { nome:"Follow-up trimestral #1", dias:90, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #2", dias:180, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #3", dias:270, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #4", dias:360, subatividades:["Contacto com cliente — estado do projecto","Avaliar necessidades de ajuste","Fechar ou renovar contrato"] },
  ],
  "COPSOQ": [
    { nome:"Preparação",              dias:14, subatividades:["Reunião de kickoff","Definição da amostra","Comunicação interna","Configuração da plataforma"] },
    { nome:"Aplicação",               dias:21, subatividades:["Envio do questionário","Follow-ups de adesão","Encerramento da recolha"] },
    { nome:"Análise",                 dias:14, subatividades:["Análise estatística","Construção do heatmap","Identificação de áreas de risco"] },
    { nome:"Devolução de resultados", dias:7,  subatividades:["Relatório final","Apresentação à direção"] },
    { nome:"Plano de ação",           dias:30, subatividades:["Acompanhamento de medidas","Calendarização da reavaliação"] },
  ],"WOW": [
    { nome:"S1 — Setup e Alinhamento", dias:7, subatividades:[
      "Reunião de kick-off (60min) com SPOC e Liderança cliente",
      "Preencher Briefing de Lançamento (assinado por ambas as partes)",
      "Configurar cliente na plataforma (grupos, planos, acessos)",
      "Definir canais de comunicação interna disponíveis",
      "Adaptar kit de comunicação ao cliente (emails, FAQ, claims)",
      "Definir data e formato da sessão de activação com liderança (S2)",
      "Definir data e formato da sessão com colaboradores (S3)",
    ]},
    { nome:"S2 — Activação Interna", dias:7, subatividades:[
      "Realizar sessão de activação com liderança (45-60min)",
      "Formação do SPOC na plataforma (45min)",
      "Finalizar e aprovar email de lançamento (assinado pela liderança)",
      "Confirmar lista de colaboradores e contas na plataforma",
      "Teste final de fluxo completo: acesso → anamnese → sessão",
      "Preparar deck personalizado para sessão com colaboradores (S3)",
    ]},
    { nome:"S3 — Lançamento", dias:7, subatividades:[
      "Enviar email de lançamento (assinado pela liderança)",
      "Enviar convites de acesso à plataforma a todos os colaboradores",
      "Realizar sessão de apresentação com colaboradores (60-75min)",
      "Enviar mensagem de reforço (Teams/Slack/WhatsApp interno) — Dia 18",
      "Acompanhar primeiras anamneses activas (resposta em 24h úteis)",
    ]},
    { nome:"S4 — Consolidação", dias:7, subatividades:[
      "Extrair e analisar dados de utilização iniciais (dashboard adopção)",
      "Reunião de check-in com SPOC do cliente (30min)",
      "Enviar email de reforço #2 ao colaborador",
      "Avaliar performance do Gestor de Caso (tempos de resposta)",
      "Definir cadência de check-ins futuros (mensal/bimestral)",
      "Preparar e enviar relatório de onboarding (resumo das 4 semanas)",
    ]},
    { nome:"Gestão Contínua", dias:365, subatividades:[
      "Acompanhamento mensal com SPOC",
      "Reports de utilização trimestrais",
      "Ponto de situação trimestral com liderança",
    ]},
    { nome:"Renovação", dias:30, subatividades:[
      "Revisão de KPIs e taxa de adopção",
      "Proposta de renovação",
      "Negociação e fecho",
    ]},
    { nome:"Follow-up trimestral #1", dias:90, subatividades:["Contacto com cliente — taxa de adopção e satisfação","Avaliar necessidades de sessões adicionais","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #2", dias:180, subatividades:["Contacto com cliente — taxa de adopção e satisfação","Avaliar necessidades de sessões adicionais","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #3", dias:270, subatividades:["Contacto com cliente — taxa de adopção e satisfação","Avaliar necessidades de sessões adicionais","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #4", dias:360, subatividades:["Contacto com cliente — taxa de adopção e satisfação","Avaliar necessidades de sessões adicionais","Proposta de renovação ou extensão"] },
  ],
  "Wellbeing Custom": [
    { nome:"Planeamento estratégico", dias:21,  subatividades:["Diagnóstico de necessidades","Design do programa","Validação com cliente"] },
    { nome:"Operacionalização",       dias:14,  subatividades:["Definição de cronograma","Alocação de profissionais","Comunicação interna"] },
    { nome:"Execução faseada",        dias:180, subatividades:["Implementação das várias frentes"] },
    { nome:"Avaliação e renovação",   dias:30,  subatividades:["Avaliação de impacto","Relatório final","Proposta de continuidade"] },
    { nome:"Follow-up trimestral #1", dias:90, subatividades:["Contacto com cliente — estado e satisfação","Avaliar impacto das iniciativas","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #2", dias:180, subatividades:["Contacto com cliente — estado e satisfação","Avaliar impacto das iniciativas","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #3", dias:270, subatividades:["Contacto com cliente — estado e satisfação","Avaliar impacto das iniciativas","Registar data do próximo follow-up"] },
    { nome:"Follow-up trimestral #4", dias:360, subatividades:["Contacto com cliente — estado e satisfação","Avaliar impacto das iniciativas","Fechar ou renovar contrato"] },
  ],
  "Incidentes IP - Fluxo B": [
    { nome:"Acionamento e abertura", dias:0, subatividades:[
      "Receber chamada na linha 211 451 862 — registar data e hora",
      "Identificar colaborador IP: nome, categoria profissional, local de trabalho",
      "Registar natureza da ocorrência: incidente ferroviário / acidente / outra",
      "Registar data da ocorrência e se colaborador foi retirado de funções",
      "Abrir ficha de caso no sistema",
    ]},
    { nome:"Briefing inicial e ficha de acolhimento", dias:0, subatividades:[
      "Recolha estruturada do incidente (≤2h após chamada)",
      "Preencher ficha de acolhimento: nome, categoria, local, natureza, data ocorrência",
      "Confirmar se colaborador foi retirado de funções: Sim / Não",
      "Registar modalidade pretendida: online / presencial",
    ]},
    { nome:"Consulta inicial de acolhimento (≤48h)", dias:2, subatividades:[
      "Consulta conduzida pela Elisabete — telefónica ou online, 30-50 min",
      "Registar data e hora da consulta realizada",
      "Faturar consulta inicial como tipologia B autónoma",
      "Notificar Andreia (Faturação) após conclusão",
    ]},
    { nome:"Decisão do colaborador sobre continuidade", dias:0, subatividades:[
      "Registar decisão do colaborador: Aceita continuar / Recusa",
      "Se ACEITA: informar IP da continuidade para as consultas subsequentes",
      "Se RECUSA: elaborar parecer breve da Gestora de Caso e registar",
    ]},
    { nome:"Designação de psicólogo e acesso à plataforma", dias:2, subatividades:[
      "Designar psicólogo da pool (≤48h após consulta inicial)",
      "Apoiar colaborador no acesso e registo na plataforma de consultas WoW",
      "Confirmar modalidade acordada: online / presencial",
      "Notificar Joana (Direção Clínica) com designação",
    ]},
                { nome:"Articulação com SST/Medicina do Trabalho IP", dias:21, subatividades:[
      "Obrigatória antes da avaliação pós-3 consultas — Cláusula 8.ª n.º 4 do CE",
      "Enviar pedido formal de articulação à IP",
      "Registar estado: Aguarda contacto / Em articulação / Parecer recebido",
    ]},
    { nome:"Avaliação clínica pós-3 consultas e desfecho", dias:25, subatividades:[
      "Desfecho (a) — Apto para regresso: enviar parecer à Medicina do Trabalho IP",
      "Desfecho (b) — Necessita acompanhamento: solicitar extensão de 3 sessões à IP",
      "Desfecho (c) — Encaminhamento para outras valências: registar e comunicar",
      "Informar IP do desfecho e próximos passos",
    ]},
    { nome:"Relatório individual de fim de caso", dias:28, subatividades:[
      "Elaborar relatório individual — sem informação clínica identificável (Cláusula 9.ª n.º 1.1 a)",
      "Validar relatório internamente antes de envio",
      "Enviar relatório à Cristina Barbosa (IP)",
    ]},
    { nome:"Follow-up @ 3 meses", dias:90, subatividades:[
      "Obrigatório — Cláusula 8.ª n.º 6 do CE",
      "Contactar colaborador e fazer ponto de situação",
      "Realizado pela Elisabete (casos encerrados) ou pelo profissional (se extensão)",
      "Notificar Cristina Barbosa com resultado do follow-up",
      "Registar no reporte trimestral IP",
    ]},
    { nome:"Fecho do caso", dias:92, subatividades:[
      "Confirmar follow-up @ 3 meses concluído e registado",
      "Confirmar registo no reporte trimestral IP",
      "Fechar caso definitivamente — estado: Concluído",
    ]},
  ],
  "GIC - Workwell": [
    { nome:"Fase 1 — Acionamento e triagem", dias:0, subatividades:[
      "Recepcionar chamada e identificar empresa, incidente e nº afetados",
      "Avaliar urgência e decidir resposta: telefónica ou presencial no próprio dia",
      "Dimensionar equipa de resposta e notificar Gestora de Caso",
      "Informar liderança sobre próximos passos",
    ]},
    { nome:"Fase 2 — Defusing no local (primeiras 8h)", dias:0, subatividades:[
      "Deslocar ao local e reunir com equipa afetada (se presencial)",
      "Sessão breve de estabilização e normalização (20-45 min)",
      "Entregar material de apoio escrito",
      "Identificar colaboradores que precisam de apoio imediato",
    ]},
    { nome:"Fase 3 — Avaliação individual de risco (24h)", dias:1, subatividades:[
      "Contactar individualmente colaboradores identificados em risco",
      "Classificar nível de risco por colaborador: verde / amarelo / vermelho",
      "Encaminhar casos vermelhos para apoio urgente",
      "Articular com RH e medicina do trabalho se necessário",
    ]},
    { nome:"Fase 4 — Psicoeducação com a equipa (24-48h)", dias:2, subatividades:[
      "Sessão estruturada de psicoeducação com toda a equipa",
      "Orientar líderes sobre como comunicar e apoiar as equipas",
      "Distribuir guia de autocuidado pós-incidente",
    ]},
    { nome:"Fase 5 — Debriefing CISM (48-72h)", dias:3, subatividades:[
      "Realizar debriefing estruturado CISM (protocolo 7 fases — ver doc. referência)",
      "Duração: 2-3h com equipa afetada",
      "Registar nº participantes e observações gerais",
    ]},
    { nome:"Fase 6 — Encaminhamentos individuais (1 semana)", dias:7, subatividades:[
      "Identificar colaboradores para acompanhamento clínico continuado",
      "Encaminhar para psicoterapia individual via WOW",
      "Informar RH sobre nº de encaminhamentos (sem identificação)",
    ]},
    { nome:"Fase 7 — Acompanhamento clínico individual (1-8 semanas)", dias:14, subatividades:[
      "Sessões de psicoterapia individual via WOW (online ou presencial)",
      "Avaliação de progressão a cada 3 sessões",
      "Articular com medicina do trabalho se regresso à função em risco",
    ]},
    { nome:"Fase 8 — Follow-up @ 1 mês", dias:30, subatividades:[
      "Contactar RH/liderança: estado geral da equipa",
      "Avaliar se há novos colaboradores a necessitar apoio",
      "Relatório intercalar para o cliente",
    ]},
    { nome:"Fase 9 — Follow-up @ 3 meses e fecho", dias:90, subatividades:[
      "Avaliação final do impacto da intervenção GIC",
      "Elaborar e enviar relatório final ao cliente",
      "Fechar caso no sistema",
    ]},
  ],
  // vendas dos eventos próprios: sem fases automáticas (acrescentam-se à mão, se for preciso)
  "Wellbeing Games": [],
  // formações, workshops e webinars: sem fases — o acompanhamento é feito por ação (guia, dossier e contrato), em «Ações de formação»
  "Formação": [],
  "Wellbeing Awards": [],
  "Evento": [
    { nome:"Conceção",                  dias:30, subatividades:["Definição do conceito","Agenda","Orçamento"] },
    { nome:"Logística",                 dias:30, subatividades:["Reserva de espaço","Contratação de fornecedores","Materiais"] },
    { nome:"Comunicação e inscrições",  dias:21, subatividades:["Convites","Gestão de inscrições","Follow-ups"] },
    { nome:"Execução do evento",        dias:1,  subatividades:["Coordenação no dia"] },
    { nome:"Pós-evento",                dias:14, subatividades:["Avaliação","Comunicação de resultados","Gestão de pagamentos"] },
  ],
};

const daysUntil   = d => d ? Math.ceil((new Date(d)-new Date())/(1000*60*60*24)) : null;
const fmtDate     = s => s ? new Date(s).toLocaleDateString("pt-PT",{day:"2-digit",month:"short",year:"numeric"}) : "—";
const fmtDateShort= s => s ? new Date(s).toLocaleDateString("pt-PT",{day:"2-digit",month:"short"}) : "—";

const BILLING_COR = { 'Mensal fixo':'#27AE60', 'Por sessão':'#57B1DD', 'Único':'#691FB1', 'Por marco':'#F39C12', 'Pré-pago':'#FF357B' };

export default function KanbanPage({ perms, userName, userEmail, projetoInicial }) {
  const [projects,    setProjects]    = useState([]);
  const [phases,      setPhases]      = useState([]);
  const [users,       setUsers]       = useState([]);
  const [clients,     setClients]     = useState([]);
  const [servicosCat, setServicosCat] = useState([]);
  const [catServicos, setCatServicos] = useState([]);   // catálogo em três níveis
  const [projServicos, setProjServicos] = useState([]); // o que cada projeto vende
  const [projEntidades, setProjEntidades] = useState([]); // repartição da faturação por entidade (projeto)
  const [clientesN,   setClientesN]   = useState([]);
  const [locaisN,     setLocaisN]     = useState([]);
  const [pos,         setPos]         = useState([]);   // notas de encomenda
  const [entidades,   setEntidades]   = useState([]);   // entidades de faturação
  const [loading,     setLoading]     = useState(true);
  const [modal,       setModal]       = useState(null);
  const [editProject, setEditProject] = useState(null);
  const [openProject, setOpenProject] = useState(null);
  const [filter,      setFilter]      = useState({ state:"", type:"", owner:"", search:"", area:"", commercial:"" });
  const [view,        setView]        = useState("list");
  const [clientesAbertos, setClientesAbertos] = useState({}); // nome do cliente -> aberto?
  const [kanbanType,  setKanbanType]  = useState("GL");
  const [skipModal,   setSkipModal]   = useState(null);
  const [skipReason,  setSkipReason]  = useState("");
  const [phaseModal,  setPhaseModal]  = useState(null);
  const [briefingModal, setBriefingModal] = useState(null);
  const [acaoFormacao, setAcaoFormacao] = useState(null);   // fase automática de formação → abre a ação
  const [fichaModal, setFichaModal] = useState(null);
  const [fichaGICModal, setFichaGICModal] = useState(null);
  const [editPhase,   setEditPhase]   = useState(null);
  const [custosModal, setCustosModal] = useState(null);
  const [minhasPend, setMinhasPend] = useState(0);
  // endereço: /projetos/<id> abre esse projeto (também os links antigos ?page=kanban&projeto=<id>)
  const projetoPendente = useRef(projetoInicial || (segmentosRota()[0] === 'projetos' ? segmentosRota()[1] : null) || null);
  const projectsRef = useRef([]); projectsRef.current = projects;
  const abrirProjetoDoLink = (id) => {
    const p = projectsRef.current.find(x => x.id === id); if (!p) return false;
    setView('list'); setClientesAbertos(a => ({ ...a, [p.client || '(sem cliente)']: true })); setOpenProject(p);
    setTimeout(() => { const el = document.getElementById('proj-' + p.id); if (el) el.scrollIntoView({ behavior:'smooth', block:'start' }); }, 350);
    return true;
  };
  useEffect(() => {
    const id = projetoPendente.current; if (!id || !projects.length) return;
    projetoPendente.current = null;
    if (!abrirProjetoDoLink(id)) irPara('/projetos', { modulo:'projetos', substituir:true });
  }, [projects]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (projetoPendente.current) return;   // ainda à espera dos projetos para abrir o do link
    irPara(openProject ? `/projetos/${openProject.id}` : '/projetos', { modulo:'projetos' });
  }, [openProject && openProject.id]); // eslint-disable-line react-hooks/exhaustive-deps
  useAoVoltar(() => {
    const s = segmentosRota(); if (s[0] !== 'projetos') return;
    if (!s[1]) setOpenProject(null); else if (!openProject || openProject.id !== s[1]) abrirProjetoDoLink(s[1]);
  });

  const refreshMinhasPend = async () => {
    try {
      if (!userEmail) return;
      const hoje = new Date().toISOString().slice(0,10);
      const { count } = await supabase.from('project_tarefas')
        .select('id', { count:'exact', head:true })
        .eq('feita', false).lte('data_lembrete', hoje)
        .or(`responsavel_email.eq.${userEmail},and(responsavel_email.is.null,autor_email.eq.${userEmail})`);
      setMinhasPend(count || 0);
    } catch(e) { /* não bloqueia */ }
  };

  useEffect(() => { refreshMinhasPend(); /* eslint-disable-next-line */ }, [userEmail]);

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
    const [{ data: proj, error: projErr }, { data: ph, error: phErr }, { data: usr }, { data: cl }, { data: cln }, { data: loc }, { data: posCli }, { data: entsFat }, { data: svc }, { data: catSrv }, { data: projSrv }] = await Promise.all([
      supabase.from('projects').select('*').eq('active', true).order('created_at', { ascending: false }),
      // paginado: o Supabase devolve no máximo 1000 linhas e há mais fases do que isso
      (async () => { let todas=[]; for(let i=0;;i++){ const { data, error } = await supabase.from('project_phases').select('*').order('order_num').order('id').range(i*1000,i*1000+999); if(error) return { data:todas.length?todas:null, error }; todas=todas.concat(data||[]); if(!data||data.length<1000) break; } return { data:todas, error:null }; })(),
      supabase.from('user_roles').select('email, full_name, role').eq('active', true).order('full_name'),
      supabase.from('clients').select('name').eq('active', true).order('name'),
      supabase.from('clientes').select('id,nome').order('nome'),
      supabase.from('locais').select('id,nome,cliente_id').order('nome'),
      supabase.from('pos_estado').select('*'),
      supabase.from('entidades_faturacao').select('id,cliente_id,designacao_fiscal,nif,email_faturacao,contacto_fin_nome,contacto_fin_email').eq('ativo',true),
      supabase.from('orc_servicos').select('codigo,nome,linha,ativo').order('linha').order('nome'),   // inclui os inativos: só aparecem nos projetos que já os usam
      supabase.from('catalogo_servicos').select('area,nome').eq('ativo', true).order('area').order('ordem'),
      supabase.from('projeto_servicos').select('projeto_id,area,servico'),
    ]);
    if (projErr) console.error('Erro projects:', projErr);
    if (phErr) console.error('Erro phases:', phErr);
    if (proj) setProjects(proj);
    if (ph)   setPhases(ph);
    if (usr)  setUsers(usr);
    if (cl)   setClients(cl);
    if (svc)  setServicosCat(svc);
    if (cln)  setClientesN(cln);
    if (loc)  setLocaisN(loc);
    if (posCli) setPos(posCli);
    if (entsFat) setEntidades(entsFat);
    if (catSrv) setCatServicos(catSrv);
    if (projSrv) setProjServicos(projSrv);
    try { const { data: pe } = await supabase.from('projeto_entidades').select('*'); setProjEntidades(pe || []); } catch (e) { /* tabela ainda não criada */ }
    } catch(e) { console.error('Erro loadAll:', e); }
    setLoading(false);
  };

  // notificarResponsavel: envia email ao Responsavel Operacoes + aos 2 TL quando o
  // responsavel e definido/alterado num projeto (a atribuicao acontece depois de o
  // projeto ja existir e de os TL/admins ja terem sido avisados da criacao).
  const notificarResponsavel = async (proj) => {
    try {
      const TL = [
        { email:'dinis.santos@workwell.pt', nome:'Dinis Santos' },
        { email:'joana.santos@workwell.pt', nome:'Joana Santos' },
      ];
      const primeiroNome = (proj.owner_name || proj.owner_email || '').split(' ')[0];
      const respNome = proj.owner_name || proj.owner_email || 'a pessoa responsavel';
      const descItens = (proj.description||'').trim();
      const blocoDesc = descItens ? `<div style="background:#EAF0FF;border-left:3px solid #57B1DD;border-radius:6px;padding:12px 14px;margin-bottom:12px"><div style="font-size:11px;font-weight:700;color:#1A6FA0;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px">Detalhe do orcamento</div><div style="font-size:13px;color:#333;line-height:1.6;white-space:pre-line">${descItens.replace(/</g,'&lt;')}</div></div>` : '';
      const HUB_URL = 'https://hub.workwell.pt';
      const html = `<div style="font-family:Helvetica,Arial,sans-serif;max-width:480px;margin:0 auto;padding:24px;color:#1A1A2E"><div style="background:#691FB1;border-radius:12px 12px 0 0;padding:18px 24px"><span style="color:#fff;font-size:18px;font-weight:700">&#128203; Novo projeto atribuido</span></div><div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:24px"><p style="font-size:15px;margin:0 0 16px">Ola ${primeiroNome},</p><p style="font-size:14px;line-height:1.6;color:#555;margin:0 0 16px">Foste definido/a como <b>Responsavel de Operacoes</b> pelo seguimento do projeto:</p><div style="background:#F7F5FC;border:1px solid #E4DEFA;border-radius:8px;padding:14px;margin-bottom:12px"><div style="font-weight:700;color:#691FB1;font-size:15px;margin-bottom:4px">${proj.name||'(sem nome)'}</div><div style="font-size:13px;color:#555">Cliente: ${proj.client||'-'}</div>${proj.business_area?`<div style="font-size:13px;color:#555">Linha: ${proj.business_area}</div>`:''}${proj.contract_start?`<div style="font-size:13px;color:#555">Inicio: ${proj.contract_start}</div>`:''}</div>${blocoDesc}<div style="background:#FFF6E5;border:1px solid #F39C12;border-radius:8px;padding:12px 14px;margin-bottom:16px"><div style="font-size:13px;color:#8A5A00;line-height:1.6">&#128221; <b>Importante:</b> regista todas as atualizacoes do projeto nas <b>notas das fases</b>, para manteres o hist&oacute;rico organizado e a equipa a par.</div></div><div style="text-align:center;margin:8px 0 4px"><a href="${HUB_URL}" style="display:inline-block;background:#691FB1;color:#fff;text-decoration:none;font-size:14px;font-weight:700;padding:12px 28px;border-radius:8px">Ir para o projeto</a></div></div></div>`;
      const htmlTL = `<div style="font-family:Helvetica,Arial,sans-serif;max-width:480px;margin:0 auto;padding:24px;color:#1A1A2E"><div style="background:#691FB1;border-radius:12px 12px 0 0;padding:18px 24px"><span style="color:#fff;font-size:18px;font-weight:700">&#128203; Responsavel atribuido a um projeto</span></div><div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:24px"><p style="font-size:14px;line-height:1.6;color:#555;margin:0 0 16px"><b>${respNome}</b> foi definido/a como Responsavel de Operacoes pelo seguimento do projeto:</p><div style="background:#F7F5FC;border:1px solid #E4DEFA;border-radius:8px;padding:14px;margin-bottom:12px"><div style="font-weight:700;color:#691FB1;font-size:15px;margin-bottom:4px">${proj.name||'(sem nome)'}</div><div style="font-size:13px;color:#555">Cliente: ${proj.client||'-'}</div>${proj.business_area?`<div style="font-size:13px;color:#555">Linha: ${proj.business_area}</div>`:''}${proj.contract_start?`<div style="font-size:13px;color:#555">Inicio: ${proj.contract_start}</div>`:''}</div><p style="font-size:12px;color:#999;margin:0">Notificacao automatica do HUB Workwell.</p></div></div>`;
      // Responsavel: email pessoal. TL: aviso informativo.
      const envios = [
        { email: proj.owner_email, nome: proj.owner_name || proj.owner_email, corpo: html },
        ...TL.map(t => ({ email: t.email, nome: t.nome, corpo: htmlTL })),
      ];
      for (const d of envios) {
        if (!d.email) continue;
        await supabase.functions.invoke('Send-email', { body: {
          to: d.email, toName: d.nome, subject: 'Responsavel atribuido: '+(proj.name||''),
          html: d.corpo, fromName: 'Workwell - Projetos',
        }});
      }
    } catch(e) { console.error('notificarResponsavel (nao bloqueia):', e); }
  };

  // Os serviços que o projeto vende vivem em projeto_servicos. É por eles que
  // as sessões do calendário lhe são atribuídas — sem isto, uma sessão contava
  // em todos os projetos do cliente.
  const guardarServicos = async (projetoId, nomes) => {
    if (!projetoId) return;
    const escolhidos = Array.isArray(nomes) ? nomes : [];
    const comArea = (catServicos||[]).filter(s => escolhidos.includes(s.nome));
    await supabase.from('projeto_servicos').delete().eq('projeto_id', projetoId);
    if (comArea.length) {
      const { error } = await supabase.from('projeto_servicos').insert(
        comArea.map(s => ({ projeto_id: projetoId, area: s.area, servico: s.nome })));
      if (error) alert('Não consegui guardar os serviços: ' + error.message);
    }
  };

  // Repartição da faturação de um projeto por várias entidades (% ou valor fixo de cada uma).
  // Com uma só entidade fica em projects.entidade_faturacao_id; com várias, aqui.
  const guardarRepart = async (projetoId, linhas) => {
    if (!projetoId || !Array.isArray(linhas)) return;
    const { error: e1 } = await supabase.from('projeto_entidades').delete().eq('projeto_id', projetoId);
    if (e1) { if (linhas.filter(l => l.entidade_id).length >= 2) alert('Não consegui guardar a repartição por entidades: ' + e1.message); return; }
    const rows = linhas.filter(l => l.entidade_id).map(l => ({ projeto_id: projetoId, entidade_id: l.entidade_id,
      tipo: l.tipo === 'fixo' ? 'fixo' : 'percentagem', valor: l.valor === '' || l.valor == null ? null : Number(String(l.valor).replace(',', '.')) }));
    if (rows.length >= 2) {
      const { error } = await supabase.from('projeto_entidades').insert(rows);
      if (error) alert('Não consegui guardar a repartição por entidades: ' + error.message);
    }
  };

  const saveProject = async (data) => {
    // Detetar se o Responsavel Operacoes e novo ou mudou (para notificar so nesse caso)
    const respAnterior = editProject?.owner_email || null;
    const respNovo = data.owner_email || null;
    const responsavelMudou = respNovo && respNovo !== respAnterior;
    // Limpar campos numéricos
    const clean = {
      name: data.name||null,
      client: data.client||null,
      cliente_id: data.cliente_id||null,
      po_id: data.po_id || null,
      entidade_faturacao_id: data.entidade_faturacao_id || null,
      servico_codigo: data.servico_codigo || null,
      ...(Array.isArray(data.linhas_faturacao) ? { linhas_faturacao: data.linhas_faturacao
          .filter(l => l && (l.codigo || l.descricao) && Number(String(l.preco_unit).replace(',','.')) > 0)
          .map(l => ({ codigo: l.codigo || null, descricao: (l.descricao||'').trim() || null,
                       qtd: Number(String(l.qtd).replace(',','.')) || 1, preco_unit: Number(String(l.preco_unit).replace(',','.')) || 0,
                       // passagem às Operações: responsável e aceitação de cada serviço do evento
                       ...(l.area ? { area: l.area } : {}), ...(l.resp_email ? { resp_email: l.resp_email, resp_nome: l.resp_nome || null } : {}),
                       ...(l.aceite_em ? { aceite_em: l.aceite_em, aceite_por: l.aceite_por || null } : {}) })) } : {}),
      fat_contacto_nome:  data.fat_contacto_nome  || null,
      fat_contacto_email: data.fat_contacto_email || null,
      local_id: data.local_id||null,
      project_type: data.project_type||'Standard',
      ...(ehEvento(data.project_type) || data.marketing_projeto_id ? { marketing_projeto_id: ehEvento(data.project_type) ? (data.marketing_projeto_id || null) : null } : {}),
      status: data.status||'Em proposta',
      billing_model: data.billing_model||null,
      billing_month: data.billing_month||null,
      ...(Array.isArray(data.plano_faturacao) ? { plano_faturacao: data.plano_faturacao.filter(t=>t&&t.mes).map(t=>({ mes:String(t.mes).slice(0,7), tipo:t.tipo==='fixo'?'fixo':'percentagem', valor: t.valor===''||t.valor==null?null:Number(String(t.valor).replace(',','.')) })) } : {}),
      meses_pausa: Array.isArray(data.meses_pausa)?data.meses_pausa:[],
      owner_email: data.owner_email||null,
      owner_name: data.owner_name||null,
      commercial_email: data.commercial_email||null,
      commercial_name: data.commercial_name||null,
      business_area: (Array.isArray(data.business_areas) && data.business_areas.length>0) ? data.business_areas[0] : (data.business_area||'Mind'),
      business_areas: Array.isArray(data.business_areas) ? data.business_areas : (data.business_area ? [data.business_area] : null),
      servicos: Array.isArray(data.servicos) ? data.servicos : null,
      tipo_negocio: data.tipo_negocio||null,
      sem_comissao: data.sem_comissao||false,
      comissao_fixa: data.comissao_fixa ?? null,
      comissao_fixa_nota: data.comissao_fixa_nota||'',
      comissao_nota: data.comissao_nota||'',
      comissao_retencao: data.comissao_retencao===''||data.comissao_retencao==null ? null : Number(data.comissao_retencao)||null,
      comissao_upsell: data.comissao_upsell===''||data.comissao_upsell==null ? null : Number(data.comissao_upsell)||null,
      comissao_novo: data.comissao_novo===''||data.comissao_novo==null ? null : Number(data.comissao_novo)||null,
      comissao_cross: data.comissao_cross===''||data.comissao_cross==null ? null : Number(data.comissao_cross)||null,
      parent_id: data.parent_id||null,
      is_mae: data.is_mae||false,
      contract_start: data.contract_start||null,
      contract_end: data.contract_end||null,
      // pack de horas de formação (contrato-quadro): nº de horas compradas; a validade é o fim do contrato
      ...(data.pack_horas !== undefined ? { pack_horas: data.pack_horas===''||data.pack_horas==null ? null : Number(data.pack_horas)||null } : {}),
      value: data.value===''||data.value===null||data.value===undefined ? null : Number(data.value)||null,
      description: data.description||null,
      notes: data.notes||null,
      active: true,
    };

    if (editProject?.id) {
      const tipoMudou = editProject.project_type !== clean.project_type;
      // quando o estado muda (ex.: Cancelado), guarda-se a data — é a partir dela que deixa de faturar
      const estadoMudou = (editProject.status||'') !== (clean.status||'');
      await supabase.from('projects').update({ ...clean, updated_at: new Date().toISOString(), ...(estadoMudou ? { status_alterado_em: new Date().toISOString() } : {}) }).eq('id', editProject.id);
      await guardarServicos(editProject.id, data.servicos);
      await guardarRepart(editProject.id, data.repart);
      // mudou o comercial: os follow-ups trimestrais por fazer passam para o novo comercial
      if ((editProject.commercial_email||'') !== (clean.commercial_email||'') && clean.commercial_email) {
        await supabase.from('project_tarefas')
          .update({ responsavel_email: clean.commercial_email, responsavel_nome: clean.commercial_name || clean.commercial_email })
          .eq('project_id', editProject.id).ilike('texto', 'Follow-up trimestral%').not('feita', 'is', true);
      }
      // sem follow-ups (comercial novo, ou datas acabadas de preencher): criar os que faltam
      if (clean.commercial_email && temFollowups(clean.project_type)) await criarFollowups(supabase, editProject.id);
      if (responsavelMudou) {
        // passagem por aceitar: escolher o responsável aqui é o mesmo que nomeá-lo no painel da passagem
        // (recebe a tarefa e o email para aceitar); nos restantes projetos, o aviso de sempre
        if (passagemAberta(editProject)) {
          try { await nomear({ ...editProject, ...clean, id: editProject.id }, { email: clean.owner_email, nome: clean.owner_name || clean.owner_email }, { email: userEmail, nome: userName || userEmail }); }
          catch (e) { notificarResponsavel({ ...clean, id: editProject.id }); }
        } else {
          // passagem já aceite: o responsável da passagem acompanha o «Responsável Operações» do projeto
          if (editProject.passagem_estado && clean.owner_email) {
            await supabase.from('projects').update({ passagem_resp_email: clean.owner_email, passagem_resp_nome: clean.owner_name || clean.owner_email }).eq('id', editProject.id);
          }
          notificarResponsavel({ ...clean, id: editProject.id });
        }
      }
      // vendas de eventos: receita prevista no evento do Marketing (cria, atualiza ou retira)
      if (ehEvento(clean.project_type) || ehEvento(editProject.project_type)) await sincronizarReceita(supabase, { ...clean, id: editProject.id });
      if (data.parent_id) { await supabase.from('projects').update({ is_mae: true }).eq('id', data.parent_id); }
      // projeto que passa a «Formação» (ex.: veio de um orçamento ganho): cria a ação, como na criação do projeto.
      // Em qualquer projeto de formação, garante a tarefa do comercial nas ações cujo contrato ainda não foi enviado.
      if (clean.project_type === 'Formação') {
        let { data: acoesP } = await supabase.from('formacao_acoes').select('*').eq('project_id', editProject.id);
        if (!acoesP || !acoesP.length) {
          const { data: nova } = await supabase.from('formacao_acoes').insert({ project_id: editProject.id, cliente_id: clean.cliente_id || null, titulo: clean.name,
            data: clean.contract_start || null, tipo_acao: 'Formação', enquadramento: 'isenta', modalidade: 'Online', plataforma: 'Teams Workwell',
            criado_por: userName || userEmail || null }).select('*').single();
          acoesP = nova ? [nova] : [];
        }
        for (const ac of acoesP) if (!ac.condicoes_enviadas_em && !ac.condicoes_aceites_em && ac.estado !== 'Cancelada') await tarefaComercial(supabase, ac);
      }
      // a fase de Execução acompanha sempre as datas do contrato
      if (clean.contract_start && clean.contract_end && clean.contract_end >= clean.contract_start) {
        try { await sincronizarFasesContrato(supabase, editProject.id, clean.contract_start, clean.contract_end); } catch (e) { console.error('fase execução:', e); }
      }
      if (tipoMudou && TEMPLATES[clean.project_type]) {
        const ok = window.confirm(ehEvento(clean.project_type)
          ? 'Mudaste o tipo de projeto para "'+clean.project_type+'".\n\nAs fases e os follow-ups por fazer deste projeto vão ser apagados (os eventos não têm fases automáticas; podes acrescentar à mão).\n\nContinuar?'
          : 'Mudaste o tipo de projeto para "'+clean.project_type+'".\n\nIsto vai SUBSTITUIR as fases atuais pelas do novo tipo (o trabalho feito nas fases antigas perde-se).\n\nContinuar?');
        if (ok) {
          await supabase.from('project_phases').delete().eq('project_id', editProject.id);
          const tmplN = TEMPLATES[clean.project_type].filter(t => !ehFollowup(t.nome));
          const datasN = datasFases(tmplN, clean.contract_start, clean.contract_end);
          const novasFases = tmplN.map((t, i) => {
            return { project_id: editProject.id, name: t.nome, order_num: i + 1, state: "Por iniciar",
              start_date: datasN[i].start, end_date: datasN[i].end,
              subtasks: JSON.stringify(t.subatividades.map(se => ({ name:se, state:"Pendente", type:"Reunião", notes:"" }))) };
          });
          if (novasFases.length) await supabase.from('project_phases').insert(novasFases);
          if (ehEvento(clean.project_type)) await supabase.from('project_tarefas').delete().eq('project_id', editProject.id).ilike('texto', 'Follow-up trimestral%').not('feita', 'is', true);
          if (temFollowups(clean.project_type)) await criarFollowups(supabase, editProject.id);
        }
      }
    } else {
      const { data: proj } = await supabase.from('projects').insert(clean).select('id,project_type,contract_start').single();
      if (proj?.id) { await guardarServicos(proj.id, data.servicos); await guardarRepart(proj.id, data.repart); }
      if (responsavelMudou && proj) { notificarResponsavel({ ...clean, id: proj.id }); }
      if (data.parent_id) { await supabase.from('projects').update({ is_mae: true }).eq('id', data.parent_id); }
      if (proj) {
        const ini = [];
        if (clean.description && clean.description.trim()) ini.push({ project_id: proj.id, tipo: 'descricao', texto: clean.description.trim(), autor: userName||userEmail||null });
        if (clean.notes && clean.notes.trim()) ini.push({ project_id: proj.id, tipo: 'nota', texto: clean.notes.trim(), autor: userName||userEmail||null });
        if (ini.length) { try { await supabase.from('project_notes').insert(ini); } catch(e) { console.error('project_notes inicial:', e); } }
      }
      if (proj && !clean.is_mae && clean.project_type && TEMPLATES[data.project_type]) {
        const tmplP = TEMPLATES[data.project_type].filter(t => !ehFollowup(t.nome));
        const datasP = datasFases(tmplP, data.contract_start, data.contract_end);
        const phasesToInsert = tmplP.map((t, i) => {
          return {
            project_id: proj.id, name: t.nome, order_num: i + 1,
            state: "Por iniciar",
            start_date: datasP[i].start,
            end_date:   datasP[i].end,
            subtasks: JSON.stringify(t.subatividades.map(s => ({ name:s, state:"Pendente", type:"Reunião", notes:"" }))),
          };
        });
        if (phasesToInsert.length) await supabase.from('project_phases').insert(phasesToInsert);
        if (temFollowups(data.project_type)) await criarFollowups(supabase, proj.id);
      }
      if (proj && ehEvento(clean.project_type)) {
        await sincronizarReceita(supabase, { ...clean, id: proj.id });
      }
      // projeto de formação: cria logo a primeira ação (a gestora completa a ficha)
      if (proj && clean.project_type === 'Formação') {
        const { data: acaoNova } = await supabase.from('formacao_acoes').insert({ project_id: proj.id, cliente_id: clean.cliente_id || null, titulo: clean.name,
          data: clean.contract_start || null, tipo_acao: 'Formação', enquadramento: 'isenta', modalidade: 'Online', plataforma: 'Teams Workwell',
          criado_por: userName || userEmail || null }).select('*').single();
        if (acaoNova) await tarefaComercial(supabase, acaoNova);
      }
      if (proj) await sincronizarFases(supabase, [proj.id]);
      // projeto criado à mão pelo comercial, sem responsável nas Operações: segue a passagem (como no ganho)
      if (proj && !clean.is_mae && clean.commercial_email && !clean.owner_email && !ehEvento(clean.project_type)) {
        try { await iniciarPassagem(proj.id, { contexto: clean.description || '' }); } catch (e) { console.error('passagem:', e); }
      }
    }
    // fases automáticas das ações de formação (repõe-as se a mudança de tipo apagou as fases)
    if (editProject?.id) await sincronizarFases(supabase, [editProject.id]);
    setModal(null); setEditProject(null); loadAll();
  };

  const deleteProject = async (id) => {
    const pr = (projects||[]).find(x => x.id === id);
    if (!window.confirm(`Apagar o projeto «${pr?.name || ''}»?\n\nDeixa de aparecer nos Projetos e no Financeiro (não é apagado da base — pode ser reposto).`)) return;
    await supabase.from('projects').update({ active: false }).eq('id', id);
    // o histórico do projeto (trigger na base) regista a mudança de «active»
    if (openProject?.id === id) setOpenProject(null);
    loadAll();
  };

  // passagem às Operações por aceitar: as fases ficam bloqueadas
  const bloqueadoPorFase = (faseId, projectId) => {
    const pid = projectId || ((phases||[]).find(x => x.id === faseId) || {}).project_id;
    const pr = (projects||[]).find(x => x.id === pid);
    const m = bloqueio(pr);
    if (m) { alert(`«${pr.name}» está bloqueado: ${m}.\n\nAs fases só avançam depois de as Operações aceitarem a passagem (no topo do projeto).`); return true; }
    return false;
  };

  const updatePhase = async (id, patch) => {
    if (bloqueadoPorFase(id)) return;
    await supabase.from('project_phases').update(patch).eq('id', id);
    setPhases(pp => pp.map(p => p.id===id ? {...p,...patch} : p));
  };

  const updateSubtasks = async (phaseId, subtasks) => {
    if (bloqueadoPorFase(phaseId)) return;
    await supabase.from('project_phases').update({ subtasks: JSON.stringify(subtasks) }).eq('id', phaseId);
    setPhases(pp => pp.map(p => p.id===phaseId ? {...p, subtasks: JSON.stringify(subtasks)} : p));
  };

  const deletePhase = async (id) => {
    if (!window.confirm('Apagar esta fase?')) return;
    await supabase.from('project_phases').delete().eq('id', id);
    setPhases(pp => pp.filter(p => p.id !== id));
  };

  const savePhase = async (data) => {
    if (bloqueadoPorFase(editPhase?.id, editPhase?.id ? null : phaseModal)) return;
    if (editPhase?.id) {
      await supabase.from('project_phases').update(data).eq('id', editPhase.id);
    } else {
      const projectPhases = phases.filter(p => p.project_id === phaseModal);
      const maxOrder = projectPhases.reduce((a,b) => Math.max(a, b.order_num||0), 0);
      await supabase.from('project_phases').insert({ ...data, project_id: phaseModal, order_num: maxOrder + 1 });
    }
    setPhaseModal(null); setEditPhase(null); loadAll();
  };

  const skipPhase = async () => {
    if (!skipReason.trim()) { alert('É obrigatório indicar o motivo para saltar esta fase.'); return; }
    await updatePhase(skipModal.id, { state: "Não aplicável", skip_reason: skipReason });
    setSkipModal(null); setSkipReason("");
  };

  const filtered = projects.filter(p => {
    if (filter.state  && (p.status||"Em proposta") !== filter.state) return false;
    if (filter.type   && p.project_type !== filter.type) return false;
    if (filter.owner  && p.owner_email !== filter.owner) return false;
    if (filter.commercial && p.commercial_email !== filter.commercial) return false;
    if (filter.area) { const areas = Array.isArray(p.business_areas)&&p.business_areas.length ? p.business_areas : (p.business_area?[p.business_area]:[]); if (!areas.includes(filter.area)) return false; }
    if (filter.search) {
      // pesquisa sem acentos, por todas as palavras, no nome, no cliente e no nome do programa-mãe
      // (ex.: «Volkswagen» encontra «VW Digital Solutions — Aulas», filho de «Volkswagen Digital Solutions Programa»)
      const norm = (x) => String(x||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const mae = p.parent_id ? projects.find(x => x.id === p.parent_id) : null;
      const alvo = norm([p.name, p.client, mae?.name].join(' '));
      if (!norm(filter.search).split(/\s+/).filter(Boolean).every(w => alvo.includes(w))) return false;
    }
    return true;
  });

  // Agrupar: mães primeiro, cada um seguido dos seus subprojetos
  const agrupados = (() => {
    const byId = {}; filtered.forEach(p => { byId[p.id] = p; });
    const ehMaeValida = (id) => { const m = byId[id]; return !!(m && m.is_mae); };
    const maes = filtered.filter(p => p.is_mae);
    // filhos: só contam como filhos se o parent_id apontar para uma mãe VÁLIDA presente
    const filhosPorMae = {};
    filtered.forEach(p => {
      if (p.parent_id && !p.is_mae && ehMaeValida(p.parent_id)) {
        (filhosPorMae[p.parent_id] ||= []).push(p);
      }
    });
    // soltos: não é mãe, e não tem parent válido (inclui parent_id órfãos → tratados como soltos)
    const soltos = filtered.filter(p => !p.is_mae && !(p.parent_id && ehMaeValida(p.parent_id)));
    const out = [];
    maes.forEach(m => { out.push(m); (filhosPorMae[m.id]||[]).forEach(f => out.push(f)); });
    return [...out, ...soltos];
  })();

  // porCliente: pega nos projetos ja ordenados (mae -> filhos -> soltos) e agrupa-os
  // por cliente, para a vista Lista os mostrar dentro de cards (A-Z).
  const porCliente = (() => {
    const mapa = {};
    agrupados.forEach(p => {
      const nome = p.client || '(sem cliente)';
      if (!mapa[nome]) mapa[nome] = { cliente: nome, projetos: [], valor: 0, tipos: new Set() };
      mapa[nome].projetos.push(p);
       mapa[nome].valor += (Number(p.value) || 0);
      if (p.billing_model) mapa[nome].tipos.add(p.billing_model);
    });
    return Object.values(mapa)
      .map(c => ({ ...c, tipos: [...c.tipos] }))
      .sort((a, b) => a.cliente.localeCompare(b.cliente, 'pt'));
  })();

  // Fim de contrato: só alerta os modelos que se RENOVAM. Um webinar ou uma
  // formação ("Único"/"Por marco") tem data de fim porque é um evento — acaba
  // e não há nada a decidir. Antes eram 27 eventos no meio de 9 contratos reais.
  const MODELOS_RENOVAVEIS = ['Mensal fixo','Pré-pago','Por sessão'];
  const alerts = projects.filter(p => {
    if (!MODELOS_RENOVAVEIS.includes(p.billing_model || '')) return false;
    const days = daysUntil(p.contract_end);
    return days !== null && days > 0 && days <= 90 && p.status === "Ativo";
  });

  // Alertas de follow-up trimestral
  const followupAlerts = phases
    .filter(ph => ph.name?.toLowerCase().includes('follow-up') && ph.state === 'Por iniciar')
    .map(ph => {
      const proj = projects.find(p => p.id === ph.project_id);
      const days = daysUntil(ph.end_date);
      return { ...proj, phase: ph, daysFollowup: days };
    })
    .filter(x => x.daysFollowup !== null && x.daysFollowup >= 0 && x.daysFollowup <= 30);

  const kanbanProjects   = filtered.filter(p => p.project_type === kanbanType);
  const kanbanPhaseNames = TEMPLATES[kanbanType]?.filter(t => !ehFollowup(t.nome)).map(t => t.nome) || [];
  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", padding:24 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>

      {view==="alertas" && <>
      <div style={{ fontSize:11.5, color:C.textLight, marginBottom:12, lineHeight:1.6 }}>
        Contratos que se renovam (mensal fixo, pré-pago, por sessão) a terminar nos próximos 90 dias.
        Eventos pontuais — webinars, formações — não aparecem aqui: acabam e não há renovação a decidir.
      </div>
      {followupAlerts.length===0 && alerts.length===0 && <div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:`1px solid ${C.border}` }}>Sem alertas neste momento. 🎉</div>}
      {/* ALERTAS FOLLOW-UP */}
      {followupAlerts.length>0&&(
        <div style={{ marginBottom:8 }}>
          {followupAlerts.map((p,i)=>{
            const days=p.daysFollowup;
            const color=days<=7?"#E74C3C":days<=15?"#F39C12":"#691FB1";
            const bg=days<=7?"#FDEDEC":days<=15?"#FEF9E7":"#EDE7F6";
            return(
              <div key={i} style={{ background:bg, border:`1px solid ${color}`, borderRadius:8, padding:'10px 16px', marginBottom:8, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <span style={{ fontWeight:700, fontSize:13, color }}>{p.name} — {p.client}</span>
                  <span style={{ fontSize:12, color:'#666', marginLeft:8 }}>{p.phase?.name}</span>
                </div>
                <span style={{ background:color, color:'white', borderRadius:5, padding:'2px 8px', fontWeight:700, fontSize:12 }}>
                  {days===0?'Hoje':days===1?'Amanhã':`${days} dias`}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* ALERTAS RENOVAÇÃO */}
      {alerts.length>0&&(
        <div style={{ marginBottom:16 }}>
          {alerts.map(p=>{
            const days=daysUntil(p.contract_end);
            const color=days<=30?"#E74C3C":days<=60?"#F39C12":"#57B1DD";
            const bg=days<=30?"#FDEDEC":days<=60?"#FEF9E7":"#E5F7FF";
            return(
              <div key={p.id} style={{ background:bg, border:`1px solid ${color}`, borderRadius:9, padding:"10px 16px", marginBottom:6, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                <span style={{ fontSize:13, color, fontWeight:600 }}>⚠️ <strong>{p.name}</strong> — contrato termina em <strong>{days} dias</strong> ({fmtDate(p.contract_end)})</span>
                <span style={{ fontSize:11, color, background:"white", borderRadius:5, padding:"2px 8px", fontWeight:700 }}>{days<=30?"🔴 30 dias":days<=60?"🟡 60 dias":"🔵 90 dias"}</span>
              </div>
            );
          })}
        </div>
      )}
      </>}

      {/* HEADER */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div>
          <h2 style={{ margin:0, fontFamily:"'Fraunces',serif", color:C.purple, fontSize:22 }}>Projetos</h2>
          <p style={{ margin:"4px 0 0", fontSize:12, color:C.textLight }}>{filtered.length} projetos · {filtered.reduce((a,b)=>a+(b.value||0),0).toLocaleString("pt-PT")}€ em pipeline</p>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {(()=>{ const nAlert=alerts.length+followupAlerts.length; const critico=alerts.some(p=>{const d=daysUntil(p.contract_end);return d!==null&&d<=30;})||followupAlerts.some(p=>p.daysFollowup<=7); return [["list","☰ Lista"],["kanban","⊞ Por fases"],["cliente","🏢 Vista Cliente"],["tarefas","🗒 As minhas tarefas"+(minhasPend>0?" ("+minhasPend+")":"")],["alertas","🔔 Alertas"+(nAlert>0?" ("+nAlert+")":"")]].map(([v,lbl])=>(
            <button key={v} onClick={()=>setView(v)} style={{ background:view===v?C.purpleLight:"transparent", border:`1px solid ${v==="alertas"&&critico?"#E74C3C":(view===v?C.purple:C.border)}`, borderRadius:7, color:v==="alertas"&&critico?"#E74C3C":(view===v?C.purple:C.textLight), padding:"6px 12px", fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:view===v||(v==="alertas"&&critico)?700:400 }}>
              {lbl}
            </button>
          )); })()}
          {false && [["list","☰ Lista"]].map(([v,lbl])=>(
            <button key={v} onClick={()=>setView(v)} style={{ background:view===v?C.purpleLight:"transparent", border:`1px solid ${view===v?C.purple:C.border}`, borderRadius:7, color:view===v?C.purple:C.textLight, padding:"6px 12px", fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:view===v?700:400 }}>
              {lbl}
            </button>
          ))}
          {perms?.canEditProjects&&(
            <button onClick={()=>{ setEditProject(null); setModal('project'); }}
              style={{ background:C.purple, border:'none', borderRadius:8, color:'white', padding:'8px 16px', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>
              + Novo Projeto
            </button>
          )}
        </div>
      </div>

      {/* FILTROS */}
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        <input value={filter.search} onChange={e=>setFilter(f=>({...f,search:e.target.value}))} placeholder="Pesquisar projeto ou cliente..."
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none', width:220 }}/>
        <select value={filter.state} onChange={e=>setFilter(f=>({...f,state:e.target.value}))}
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
          <option value="">Todos os estados</option>
          {Object.keys(PROJECT_STATES).map(s=><option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filter.type} onChange={e=>setFilter(f=>({...f,type:e.target.value}))}
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
          <option value="">Todos os tipos</option>
          {PROJECT_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        <select value={filter.owner} onChange={e=>setFilter(f=>({...f,owner:e.target.value}))}
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
          <option value="">Todos os responsáveis</option>
          {users.map(u=><option key={u.email} value={u.email}>{u.full_name}</option>)}
        </select>
        <select value={filter.commercial} onChange={e=>setFilter(f=>({...f,commercial:e.target.value}))}
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
          <option value="">Todos os comerciais</option>
          {[...new Map(projects.filter(p=>p.commercial_email).map(p=>[p.commercial_email,p.commercial_name||p.commercial_email])).entries()].map(([em,nm])=><option key={em} value={em}>{nm}</option>)}
        </select>
        <select value={filter.area} onChange={e=>setFilter(f=>({...f,area:e.target.value}))}
          style={{ padding:'7px 11px', border:`1px solid ${C.border}`, borderRadius:7, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
          <option value="">Todas as linhas</option>
          {LINHAS.map(a=><option key={a} value={a}>{LINHA_ICON[a]||''} {a}</option>)}
        </select>
        {(filter.search||filter.state||filter.type||filter.owner||filter.area||filter.commercial)&&(
          <button onClick={()=>setFilter({state:"",type:"",owner:"",search:"",area:"",commercial:""})} style={{ background:'none', border:'none', color:C.textLight, fontSize:11, cursor:'pointer', textDecoration:'underline' }}>Limpar</button>
        )}
      </div>

      {loading?<div style={{ textAlign:'center', padding:40, color:C.textLight }}>A carregar...</div>:(
        <>
          {/* LISTA VIEW */}
          {view==="cliente"&&<ClienteView voltar={()=>setView("list")}/>}
          {view==="tarefas"&&<MinhasTarefas userEmail={userEmail} projects={projects} onAbrirProjeto={(pid)=>{ const p=projects.find(x=>x.id===pid); if(p){ setView("list"); } }}/>}
          {view==="list"&&(
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {filtered.length===0&&<div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:`1px solid ${C.border}` }}>Sem projetos. Clica em "+ Novo Projeto" para começar.</div>}
              {/* CARD_CLIENTE: projetos arrumados dentro de um card por cliente (A-Z). */}
              {porCliente.map(cl=>{
                const aberto = !!clientesAbertos[cl.cliente];
                const nProj = cl.projetos.length;
                return (
                <div key={cl.cliente} style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`, overflow:'hidden' }}>
                  <div onClick={()=>setClientesAbertos(a=>({...a,[cl.cliente]:!a[cl.cliente]}))}
                    style={{ padding:'14px 18px', display:'flex', alignItems:'center', gap:12, cursor:'pointer', background:aberto?C.purpleLight:C.white }}>
                    <span style={{ fontSize:13, color:C.purple, width:14 }}>{aberto?'▾':'▸'}</span>
                    <span style={{ flex:1, fontSize:15, fontWeight:700, color:C.purple, fontFamily:"'Fraunces',serif" }}>{cl.cliente}</span>
                    <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                      {cl.tipos.map(t=>{ const cor=BILLING_COR[t]||'#8888AA'; return (
                        <span key={t} style={{ background:cor+'22', color:cor, borderRadius:6, padding:'3px 8px', fontSize:10, fontWeight:700 }}>{t}</span>
                      ); })}
                    </div>
                    <span style={{ fontSize:12, color:C.textLight, minWidth:78, textAlign:'right' }}>{nProj} {nProj===1?'projeto':'projetos'}</span>
                    <span style={{ fontSize:13, fontWeight:700, color:C.purple, minWidth:88, textAlign:'right' }}>{cl.valor>0?cl.valor.toLocaleString('pt-PT')+'€':'—'}</span>
                  </div>
                  {aberto && (
                  <div style={{ padding:'0 10px 10px', display:'flex', flexDirection:'column', gap:8 }}>
              {cl.projetos.map(p=>{
                const pPhases=phases.filter(ph=>ph.project_id===p.id && !(ehFollowup(ph.name) && ph.state==="Não aplicável")).sort((a,b)=>a.order_num-b.order_num);
                const st=PROJECT_STATES[p.status||"Em proposta"]||PROJECT_STATES["Em proposta"];
                const days=daysUntil(p.contract_end);
                const isOpen=openProject?.id===p.id;
                const activePh=pPhases.filter(ph=>ph.state!=="Não aplicável");
                const completedPhases=activePh.filter(ph=>ph.state==="Concluída").length;
                const progress=activePh.length>0?Math.round((completedPhases/activePh.length)*100):0;
                const ehFilho = p.parent_id && cl.projetos.some(x=>x.id===p.parent_id && x.is_mae);
                return(
                  <div key={p.id} id={'proj-' + p.id} style={{ scrollMarginTop:80, background:p.is_mae?'#B8B3E0':C.white, borderRadius:12, border:`1px solid ${p.is_mae?C.purple:(ehFilho?C.purpleLight:C.border)}`, overflow:'hidden', marginLeft:ehFilho?28:0, borderLeft:p.is_mae?`4px solid ${C.purpleDark||'#4A1A82'}`:(ehFilho?`3px solid ${C.purple}`:`1px solid ${C.border}`), opacity:p.status==='Concluído'?0.55:1 }}>
                    <div style={{ padding:'14px 20px', display:'flex', alignItems:'center', gap:12, cursor:'pointer', background:p.is_mae?'transparent':(isOpen?C.purpleLight:C.white) }} onClick={()=>setOpenProject(isOpen?null:p)}>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
                          <span style={{ fontWeight:700, fontSize:15, color:C.text }}>{p.name}</span>
                          <span style={{ background:st.bg, color:st.color, borderRadius:5, padding:'2px 8px', fontSize:11, fontWeight:600 }}>{p.status||"Em proposta"}</span>
                          {passagemAberta(p)&&<span title={bloqueio(p)||''} style={{ background:'#FDECEA', color:'#C0392B', borderRadius:5, padding:'2px 8px', fontSize:11, fontWeight:700 }}>🔒 {p.passagem_estado==='falta_info'?'Falta informação':'Passagem por aceitar'}</span>}
                          {p.project_type&&<span style={{ background:C.purpleLight, color:C.purple, borderRadius:5, padding:'2px 8px', fontSize:10, fontWeight:600 }}>{ehEvento(p.project_type)?'🎪 ':p.project_type==='Formação'?'🎓 ':''}{p.project_type}</span>}
                          {p.tipo_negocio&&(()=>{const TN={Novo:['#EAFAF1','#27AE60'],'Retenção':['#E5F7FF','#1A6FA0'],Upsell:['#EDE7F6','#691FB1'],Cross:['#FFF0F5','#FF357B']};const c=TN[p.tipo_negocio]||['#F7F5FC','#8888AA'];return <span style={{ background:c[0], color:c[1], borderRadius:5, padding:'2px 8px', fontSize:10, fontWeight:700 }}>{p.tipo_negocio}</span>;})()}
                          {(() => { const areas = Array.isArray(p.business_areas)&&p.business_areas.length ? p.business_areas : (p.business_area?[p.business_area]:[]); return areas.map(a => <span key={a} style={{ background:(LINHA_COR[a]||'#8888AA')+'22', color:LINHA_COR[a]||'#8888AA', borderRadius:5, padding:'2px 8px', fontSize:10, fontWeight:700, marginRight:4 }}>{LINHA_ICON[a]||''} {a}</span>); })()}
                          {days!==null&&days>0&&days<=90&&<span style={{ background:days<=30?"#FDEDEC":days<=60?"#FEF9E7":"#E5F7FF", color:days<=30?"#E74C3C":days<=60?"#F39C12":"#57B1DD", borderRadius:5, padding:'2px 8px', fontSize:10, fontWeight:700 }}>⚠ {days}d renovação</span>}
                        </div>
                        <div style={{ display:'flex', gap:14, fontSize:11, color:C.textMid, flexWrap:'wrap' }}>
                          {p.client&&<span>🏢 {p.client}</span>}
                          {p.owner_name&&<span>👤 {p.owner_name}</span>}
                          {p.commercial_name&&<span>💼 {p.commercial_name}</span>}
                          {p.contract_start&&<span>📅 {fmtDateShort(p.contract_start)} → {fmtDateShort(p.contract_end)}</span>}
                          {p.value&&<span style={{ color:C.purple, fontWeight:700 }}>💶 {p.value.toLocaleString("pt-PT")}€</span>}
                          {p.billing_model&&<span>📋 {p.billing_model}</span>}
                        </div>
                        {pPhases.length>0&&(
                          <div style={{ marginTop:6, display:'flex', alignItems:'center', gap:8 }}>
                            <div style={{ flex:1, height:4, background:C.border, borderRadius:2, overflow:'hidden' }}>
                              <div style={{ width:`${progress}%`, height:'100%', background:progress===100?C.green:C.purple, borderRadius:2, transition:'width 0.3s' }}/>
                            </div>
                            <span style={{ fontSize:10, color:C.textLight, whiteSpace:'nowrap' }}>{completedPhases}/{activePh.length} fases · {progress}%</span>
                          </div>
                        )}
                      </div>
                      <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                        {p.project_type==='WOW'&&<button onClick={e=>{e.stopPropagation();setBriefingModal(p);}} style={{ background:'#E5F7FF', border:'1px solid #57B1DD', borderRadius:6, color:'#1A6FA0', padding:'5px 9px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>📋 Briefing WOW</button>}
                        {p.project_type==='Incidentes IP - Fluxo B'&&<button onClick={e=>{e.stopPropagation();setFichaModal(p);}} style={{ background:'#FDEDEC', border:'1px solid #E74C3C', borderRadius:6, color:'#C0392B', padding:'5px 9px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>📋 Ficha IP</button>}
                        {p.project_type==='GIC - Workwell'&&<button onClick={e=>{e.stopPropagation();setFichaGICModal(p);}} style={{ background:'#EDE7F6', border:'1px solid #691FB1', borderRadius:6, color:'#691FB1', padding:'5px 9px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>📋 Ficha GIC</button>}
                        {p.project_type==='GIC - Workwell'&&<a href="https://workwellpt594.sharepoint.com/:w:/s/WORKWELL_GROUP/IQCmv75VdlZ1SaQiqpOO0QOfAX4-2_6bZxLln9Zo_0liiZQ?e=Agnscm" target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{ background:'#F7F5FC', border:'1px solid #C6C3E7', borderRadius:6, color:'#691FB1', padding:'5px 9px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600, textDecoration:'none' }}>📄 Protocolo GIC</a>}
                        <button onClick={e=>{e.stopPropagation();setCustosModal(p);}} style={{ background:'#EAF7EF', border:'1px solid #27AE60', borderRadius:6, color:'#1E8449', padding:'5px 9px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>💰 Custos</button>
                        {perms?.canEditProjects&&<button onClick={e=>{e.stopPropagation();setEditProject(p);setModal('project');}} style={{ background:C.purpleLight, border:'none', borderRadius:6, color:C.purple, padding:'5px 9px', fontSize:12, cursor:'pointer' }}>✏️</button>}
                        {perms?.canEditProjects&&<button onClick={e=>{e.stopPropagation();deleteProject(p.id);}} style={{ background:'#FADBD8', border:'none', borderRadius:6, color:'#C0392B', padding:'5px 9px', fontSize:12, cursor:'pointer' }}>🗑</button>}
                        <span style={{ color:C.textLight, fontSize:13, padding:'5px 4px' }}>{isOpen?'▲':'▼'}</span>
                      </div>
                    </div>

                    {isOpen&&(
                      <div style={{ borderTop:`1px solid ${C.border}`, padding:'16px 20px' }}>
                        <PassagemPainel p={p} users={users} userEmail={userEmail} userName={userName} onMudou={loadAll}/>
                        {p.description&&<p style={{ margin:'0 0 12px', fontSize:13, color:C.textMid, fontStyle:'italic' }}>{p.description}</p>}
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                          <span style={{ fontSize:12, fontWeight:700, color:C.textMid, textTransform:'uppercase', letterSpacing:0.8 }}>Fases do projeto</span>
                          {perms?.canEditProjects&&(
                            <button onClick={()=>{ setEditPhase(null); setPhaseModal(p.id); }}
                              style={{ background:C.purple, border:'none', borderRadius:6, color:'white', padding:'5px 12px', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
                              + Adicionar fase
                            </button>
                          )}
                        </div>
                        {pPhases.length===0&&<div style={{ color:C.textLight, fontSize:12, fontStyle:'italic' }}>Sem fases definidas.</div>}
                        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                          {pPhases.map((phase,pi)=>{
                            const phSt=PHASE_STATES[phase.state]||PHASE_STATES["Por iniciar"];
                            const isSkipped=phase.state==="Não aplicável";
                            const subtasks=(()=>{ try { return phase.subtasks?(typeof phase.subtasks==='string'?JSON.parse(phase.subtasks):phase.subtasks):[]; } catch(e){ return []; } })();
                            const doneSubtasks=subtasks.filter(s=>s.state==="Concluída").length;
                            const phaseDays=phase.start_date&&phase.end_date?Math.ceil((new Date(phase.end_date)-new Date(phase.start_date))/(1000*60*60*24)):null;
                            return(
                              <div key={phase.id} style={{ background:isSkipped?"#F8F8F8":C.bg, borderRadius:9, border:`1px solid ${isSkipped?"#DDDDDD":C.border}`, overflow:'hidden', opacity:isSkipped?0.7:1 }}>
                                <div style={{ padding:'10px 14px', display:'flex', alignItems:'center', gap:10 }}>
                                  <div style={{ width:24, height:24, borderRadius:'50%', background:phSt.bg, border:`2px solid ${phSt.color}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:phSt.color, flexShrink:0 }}>{pi+1}</div>
                                  <div style={{ flex:1, minWidth:0 }}>
                                    <div style={{ fontWeight:600, fontSize:13, color:isSkipped?C.textLight:C.text, textDecoration:isSkipped?"line-through":"none" }}>{phase.name}</div>
                                    <div style={{ fontSize:11, color:C.textMid, marginTop:2, display:'flex', gap:10, flexWrap:'wrap' }}>
                                      {phase.start_date&&<span>📅 {fmtDateShort(phase.start_date)} → {fmtDateShort(phase.end_date)}</span>}
                                      {phaseDays&&<span>⏱ {phaseDays} dias</span>}
                                      {!isSkipped&&subtasks.length>0&&<span>✓ {doneSubtasks}/{subtasks.length} tarefas</span>}
                                      {isSkipped&&phase.skip_reason&&<span style={{ color:"#E74C3C", fontStyle:'italic' }}>⚠ Motivo: {phase.skip_reason}</span>}
                                    </div>
                                  </div>
                                  {phase.formacao_acao_id&&(
                                    <button onClick={()=>setAcaoFormacao(phase.formacao_acao_id)} title="Esta fase é atualizada sozinha a partir da ação de formação"
                                      style={{ background:'#EDE7F6', border:'1px solid #691FB1', borderRadius:6, color:'#691FB1', padding:'4px 9px', fontSize:10.5, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700, whiteSpace:'nowrap', flexShrink:0 }}>
                                      🎓 Abrir a ação
                                    </button>
                                  )}
                                  {phase.formacao_acao_id&&<span style={{ background:phSt.bg, color:phSt.color, border:`1px solid ${phSt.color}44`, borderRadius:6, padding:'4px 8px', fontSize:11, fontWeight:600, flexShrink:0 }}>{phase.state}</span>}
                                  {!phase.formacao_acao_id&&perms?.canEditProjects&&!isSkipped&&(
                                    <button onClick={()=>{ setSkipModal(phase); setSkipReason(""); }}
                                      style={{ background:"#FEF9E7", border:"1px solid #F39C12", borderRadius:6, color:"#F39C12", padding:'4px 9px', fontSize:10, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600, whiteSpace:'nowrap', flexShrink:0 }}>
                                      ⏭ Saltar
                                    </button>
                                  )}
                                  {!phase.formacao_acao_id&&perms?.canEditProjects&&isSkipped&&(
                                    <button onClick={()=>updatePhase(phase.id,{state:"Por iniciar",skip_reason:null})}
                                      style={{ background:C.greenLight, border:`1px solid ${C.green}`, borderRadius:6, color:C.green, padding:'4px 9px', fontSize:10, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600, flexShrink:0 }}>
                                      ↩ Repor
                                    </button>
                                  )}
                                  {!phase.formacao_acao_id&&perms?.canEditProjects&&(
                                    <button onClick={()=>{ setEditPhase(phase); setPhaseModal(p.id); }}
                                      style={{ background:C.purpleLight, border:'none', borderRadius:6, color:C.purple, padding:'4px 8px', fontSize:11, cursor:'pointer', flexShrink:0 }}>✏️</button>
                                  )}
                                  {!phase.formacao_acao_id&&perms?.canEditProjects&&(
                                    <button onClick={()=>deletePhase(phase.id)}
                                      style={{ background:'#FADBD8', border:'none', borderRadius:6, color:'#C0392B', padding:'4px 8px', fontSize:11, cursor:'pointer', flexShrink:0 }}>🗑</button>
                                  )}
                                  {!phase.formacao_acao_id&&!isSkipped&&perms?.canEditProjects&&(
                                    <select value={phase.state} onChange={e=>updatePhase(phase.id,{state:e.target.value})}
                                      style={{ background:phSt.bg, color:phSt.color, border:`1px solid ${phSt.color}44`, borderRadius:6, padding:'4px 8px', fontSize:11, fontFamily:"'DM Sans',sans-serif", fontWeight:600, cursor:'pointer', outline:'none', flexShrink:0 }}>
                                      {Object.keys(PHASE_STATES).filter(s=>s!=="Não aplicável").map(s=><option key={s} value={s}>{s}</option>)}
                                    </select>
                                  )}
                                </div>
                                {!isSkipped&&<FaseNotas faseId={phase.id} autor={userName||userEmail||''} autorEmail={userEmail||''} projectId={phase.project_id} projectName={p.name} faseNome={phase.name||''}/>}
                                {!isSkipped&&<FaseTarefas faseId={phase.id} projectId={phase.project_id} projectName={p.name} users={users} autorEmail={userEmail||''} autorNome={userName||userEmail||''} onMudou={refreshMinhasPend}/>}
                                {!isSkipped&&subtasks.length>0&&(
                                  <div style={{ borderTop:`1px solid ${C.border}`, padding:'8px 14px 10px', display:'flex', flexDirection:'column', gap:5 }}>
                                    {subtasks.map((st2,si)=>(
                                      <div key={si} style={{ display:'flex', alignItems:'center', gap:8 }}>
                                        <input type="checkbox" checked={st2.state==="Concluída"} disabled={!!phase.formacao_acao_id} title={phase.formacao_acao_id?'Marca-se na ação de formação':''} onChange={e=>{
                                          const updated=[...subtasks]; updated[si]={...st2,state:e.target.checked?"Concluída":"Pendente"};
                                          updateSubtasks(phase.id,updated);
                                        }} style={{ cursor:'pointer', accentColor:C.purple, flexShrink:0 }}/>
                                        <span style={{ fontSize:12, color:st2.state==="Concluída"?C.textLight:C.text, textDecoration:st2.state==="Concluída"?"line-through":"none", flex:1 }}>{st2.name}</span>
                                        <span style={{ fontSize:10, color:C.textLight, background:C.white, borderRadius:4, padding:'1px 6px', border:`1px solid ${C.border}`, flexShrink:0 }}>{st2.type||"Tarefa"}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
                  </div>
                  )}
                </div>
                );
              })}
            </div>
          )}

          {/* KANBAN VIEW */}
          {view==="kanban"&&(
            <div>
              <div style={{ display:'flex', gap:8, marginBottom:14, alignItems:'center', flexWrap:'wrap' }}>
                <span style={{ fontSize:12, color:C.textLight, fontWeight:600 }}>Tipo:</span>
                {PROJECT_TYPES.map(t=>(
                  <button key={t} onClick={()=>setKanbanType(t)} style={{ background:kanbanType===t?C.purple:"transparent", border:`1px solid ${kanbanType===t?C.purple:C.border}`, borderRadius:6, color:kanbanType===t?"white":C.textLight, padding:"4px 11px", fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:kanbanType===t?700:400 }}>{t}</button>
                ))}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:`repeat(${kanbanPhaseNames.length},1fr)`, gap:10, overflowX:'auto' }}>
                {kanbanPhaseNames.map((phaseName,pi)=>{
                  const template=TEMPLATES[kanbanType][pi];
                  const projectsInPhase=kanbanProjects.filter(p=>{
                    const pPhases=phases.filter(ph=>ph.project_id===p.id&&ph.state!=="Não aplicável").sort((a,b)=>a.order_num-b.order_num);
                    const currentPhase=pPhases.find(ph=>ph.state==="Em curso")||pPhases.find(ph=>ph.state==="Por iniciar");
                    return currentPhase?.name===phaseName;
                  });
                  return(
                    <div key={phaseName} style={{ minWidth:170 }}>
                      <div style={{ background:C.purpleLight, borderRadius:'8px 8px 0 0', padding:'8px 12px', borderBottom:`2px solid ${C.purple}` }}>
                        <div style={{ fontSize:11, fontWeight:700, color:C.purple }}>{phaseName}</div>
                        <div style={{ fontSize:10, color:C.textLight, marginTop:2 }}>{ehFaseExecucao(phaseName) ? 'duração do contrato' : `${template?.dias}d`} · {projectsInPhase.length} proj.</div>
                      </div>
                      <div style={{ background:'#F0EEF8', borderRadius:'0 0 8px 8px', padding:8, minHeight:120, display:'flex', flexDirection:'column', gap:6 }}>
                        {projectsInPhase.map(p=>{
                          const st=PROJECT_STATES[p.status||"Em proposta"]||PROJECT_STATES["Em proposta"];
                          const days=daysUntil(p.contract_end);
                          return(
                            <div key={p.id} onClick={()=>{setView("list");setOpenProject(p);}} style={{ background:C.white, borderRadius:8, border:`1px solid ${C.border}`, padding:10, cursor:'pointer' }}>
                              <div style={{ fontWeight:700, fontSize:12, color:C.text, marginBottom:3 }}>{p.name}</div>
                              {p.client&&<div style={{ fontSize:10, color:C.textMid }}>🏢 {p.client}</div>}
                              <div style={{ display:'flex', justifyContent:'space-between', marginTop:5, alignItems:'center' }}>
                                <span style={{ background:st.bg, color:st.color, borderRadius:4, padding:'1px 6px', fontSize:9, fontWeight:600 }}>{p.status||"Em proposta"}</span>
                                {p.value&&<span style={{ fontSize:11, fontWeight:700, color:C.purple }}>{p.value.toLocaleString("pt-PT")}€</span>}
                              </div>
                              {days!==null&&days>0&&days<=90&&<div style={{ fontSize:9, color:days<=30?"#E74C3C":days<=60?"#F39C12":"#57B1DD", fontWeight:600, marginTop:3 }}>⚠ {days}d renovação</div>}
                            </div>
                          );
                        })}
                        {projectsInPhase.length===0&&<div style={{ color:C.textLight, fontSize:10, textAlign:'center', padding:'12px 0' }}>Sem projetos</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}

      {/* MODAL SKIP */}
      {skipModal&&(
        <div style={{ position:'fixed', inset:0, background:'rgba(26,26,46,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, backdropFilter:'blur(4px)' }} onClick={()=>setSkipModal(null)}>
          <div style={{ background:C.white, borderRadius:14, padding:24, width:420, boxShadow:'0 20px 56px rgba(0,0,0,0.22)' }} onClick={e=>e.stopPropagation()}>
            <h3 style={{ margin:'0 0 8px', fontFamily:"'Fraunces',serif", color:"#F39C12", fontSize:18 }}>⏭ Saltar fase</h3>
            <p style={{ margin:'0 0 16px', fontSize:13, color:C.textMid }}>Tens a certeza que queres saltar a fase <strong>"{skipModal.name}"</strong>? É obrigatório indicar o motivo.</p>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:C.textLight, display:'block', marginBottom:4 }}>Motivo (obrigatório)</label>
              <textarea value={skipReason} onChange={e=>setSkipReason(e.target.value)} rows={3} placeholder="Ex: Cliente não quis sessão de sensibilização; optou por comunicação interna própria..."
                style={{ width:'100%', padding:'9px 11px', border:`1px solid ${skipReason.trim()?C.green:"#E74C3C"}`, borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', resize:'vertical' }}/>
              {!skipReason.trim()&&<div style={{ fontSize:11, color:"#E74C3C", marginTop:3 }}>⚠ O motivo é obrigatório para registar o salto desta fase.</div>}
            </div>
            <div style={{ display:'flex', gap:9, marginTop:16 }}>
              <button onClick={()=>setSkipModal(null)} style={{ flex:1, padding:10, border:`1px solid ${C.border}`, borderRadius:8, background:C.white, color:C.textMid, fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
              <button onClick={skipPhase} disabled={!skipReason.trim()} style={{ flex:2, padding:10, border:'none', borderRadius:8, background:skipReason.trim()?"#F39C12":"#CCCCCC", color:'white', fontSize:13, fontWeight:700, cursor:skipReason.trim()?'pointer':'not-allowed', fontFamily:"'DM Sans',sans-serif" }}>
                Confirmar salto
              </button>
            </div>
          </div>
        </div>
      )}

      {modal==='project'&&<ProjectModal item={editProject} perms={perms} autor={userName||userEmail||''} autorEmail={userEmail||''} users={users} clients={clients} clientesN={clientesN} locaisN={locaisN} pos={pos} entidades={entidades} projEntidades={projEntidades} servicosCat={servicosCat} catServicos={catServicos} projServicos={projServicos} allProjects={projects} onClose={()=>{setModal(null);setEditProject(null);}} onSave={saveProject}/>}
      {phaseModal&&<PhaseModal item={editPhase} projectId={phaseModal} users={users} onClose={()=>{setPhaseModal(null);setEditPhase(null);}} onSave={savePhase}/>}
      {acaoFormacao&&<AcaoModal acaoId={acaoFormacao} userEmail={userEmail} userName={userName} onFechar={()=>{ setAcaoFormacao(null); loadAll(); }}/>}
      {briefingModal&&<BriefingModal projectId={briefingModal.id} projectName={briefingModal.name} onClose={()=>setBriefingModal(null)}/>}
      {fichaModal&&<FichaAcolhimentoIP projectId={fichaModal.id} projectName={fichaModal.name} codigoCaso={`IP-${new Date().getFullYear()}-${fichaModal.id.slice(0,4).toUpperCase()}`} onClose={()=>setFichaModal(null)}/>}
      {fichaGICModal&&<FichaGIC projectId={fichaGICModal.id} projectName={fichaGICModal.name} codigoCaso={`GIC-${new Date().getFullYear()}-${fichaGICModal.id.slice(0,4).toUpperCase()}`} onClose={()=>setFichaGICModal(null)}/>}
      {custosModal&&<CustosModal project={custosModal} canEdit={!!perms?.canEditProjects} onClose={()=>setCustosModal(null)}/>}
    </div>
  );
}
function PhaseModal({ item, projectId, users, onClose, onSave }) {
  const isNew = !item?.id;
  const [form, setForm] = useState(item || {
    name:'', client:'', project_type:'Standard', status:'Em proposta',
    billing_model:'Mensal fixo', billing_month:'', owner_email:'', owner_name:'',
    commercial_email:'', commercial_name:'', business_area:'Mind', business_areas:['Mind'], tipo_negocio:'Novo',
    contract_start:'', contract_end:'', value:'', description:'', notes:''
  });
  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(26,26,46,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, backdropFilter:'blur(4px)' }} onClick={onClose}>
      <div style={{ background:'#FFFFFF', borderRadius:16, padding:26, width:460, boxShadow:'0 20px 56px rgba(0,0,0,0.22)', maxHeight:'88vh', overflowY:'auto' }} onClick={e=>e.stopPropagation()}>
        <h2 style={{ margin:'0 0 20px', fontFamily:"'Fraunces',serif", color:'#691FB1', fontSize:20 }}>{isNew?'Nova Fase':'Editar Fase'}</h2>
        <div style={{ display:'grid', gap:12 }}>
          <FRow label="Nome da fase" value={form.name} onChange={v=>f('name',v)} placeholder="Ex: Planeamento interno"/>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Estado</label>
            <select value={form.state||'Por iniciar'} onChange={e=>f('state',e.target.value)}
              style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
              {Object.keys(PHASE_STATES).filter(s=>s!=='Não aplicável').map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Responsável</label>
            <select value={form.responsible_email||''} onChange={e=>{const u=users.find(u=>u.email===e.target.value);f('responsible_email',e.target.value);f('responsible_name',u?.full_name||'');}}
              style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
              <option value="">Sem responsável</option>
              {users.map(u=><option key={u.email} value={u.email}>{u.full_name} ({u.role==='admin'?'Admin':u.role==='tl'?'TL':'Op.'})</option>)}
            </select>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <FRow label="Data início" type="date" value={form.start_date} onChange={v=>f('start_date',v)}/>
            <FRow label="Data fim" type="date" value={form.end_date} onChange={v=>f('end_date',v)}/>
          </div>
          <FRow label="Descrição" value={form.description} onChange={v=>f('description',v)} placeholder="O que acontece nesta fase..."/>
        </div>
        <div style={{ display:'flex', gap:10, marginTop:20 }}>
          <button onClick={onClose} style={{ flex:1, padding:10, border:'1px solid #E4DEFA', borderRadius:8, background:'#FFFFFF', color:'#4A4A6A', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
          <button onClick={()=>{
              if(!(form.name||'').trim()){ alert('A fase tem de ter um nome.'); return; }
              // enviar SO os campos que existem na tabela project_phases
              onSave({
                name: form.name.trim(),
                state: form.state || 'Por iniciar',
                responsible_email: form.responsible_email || null,
                responsible_name: form.responsible_name || null,
                start_date: form.start_date || null,
                end_date: form.end_date || null,
                description: form.description || null,
              });
            }}
            style={{ flex:2, padding:10, border:'none', borderRadius:8, background:'#691FB1', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
            {isNew?'Criar fase':'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

function ProjectModal({ item, perms, autor, autorEmail, users, clients, clientesN=[], locaisN=[], pos=[], entidades=[], projEntidades=[], servicosCat=[], catServicos=[], projServicos=[], allProjects=[], onClose, onSave }) {
  // Os serviços vivem em projeto_servicos, não numa coluna do projeto:
  // um projeto pode vender vários, e é preciso saber a área de cada um.
  const servicosGravados = React.useMemo(
    () => (projServicos||[]).filter(x => x.projeto_id === item?.id).map(x => x.servico),
    [projServicos, item]);
  const isNew = !item?.id;
  const [form, setForm] = useState(item ? { ...item,
    servicos: ((projServicos||[]).filter(x => x.projeto_id === item.id).map(x => x.servico)),
    repart: (() => { const r = (projEntidades||[]).filter(x => x.projeto_id === item.id).map(x => ({ entidade_id: x.entidade_id, tipo: x.tipo || 'percentagem', valor: x.valor ?? '' }));
      return r.length ? r : (item.entidade_faturacao_id ? [{ entidade_id: item.entidade_faturacao_id, tipo: 'percentagem', valor: '' }] : []); })(),
    business_areas: (Array.isArray(item.business_areas)&&item.business_areas.length ? item.business_areas : (item.business_area?[item.business_area]:[])) } : {
    name:'', client:'', project_type:'Standard', status:'Em proposta',
    billing_model:'Mensal fixo', owner_email:'', owner_name:'',
    commercial_email:'', commercial_name:'', is_mae:false, business_areas:[],
    contract_start:'', contract_end:'', value:'', description:'', notes:'', servicos:[]
  });


  const f = (k,v) => setForm(p=>({...p,[k]:v}));
  // eventos do Marketing (para os projetos do tipo Wellbeing Games / Wellbeing Awards)
  const [eventosMkt, setEventosMkt] = useState([]);
  useEffect(() => { supabase.from('marketing_projetos').select('id,nome,estado,ativo,created_at').eq('ativo', true).order('created_at', { ascending:false })
    .then(({ data }) => setEventosMkt(data || [])); }, []);

  // Um programa-mãe com filhos não tem valor nem modelo próprios: quem fatura
  // são os projetos. Ter valor nos dois fazia a conta aparecer a dobrar — na
  // Tabaqueira eram 14.250€ contados duas vezes.
  const filhos = (allProjects||[]).filter(p => p.parent_id === item?.id && p.status !== 'Concluído');
  const ehMaeComFilhos = !!form.is_mae && filhos.length > 0;
  const somaFilhos = filhos.reduce((a,p)=>a+(Number(p.value)||0), 0);

  const [buscaMae, setBuscaMae] = useState('');
  const contractDays = form.contract_start && form.contract_end
    ? Math.ceil((new Date(form.contract_end)-new Date(form.contract_start))/(1000*60*60*24)) : null;

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(26,26,46,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, backdropFilter:'blur(4px)' }} onClick={onClose}>
      <div style={{ background:'#FFFFFF', borderRadius:16, padding:26, width:560, boxShadow:'0 20px 56px rgba(0,0,0,0.22)', maxHeight:'90vh', overflowY:'auto' }} onClick={e=>e.stopPropagation()}>
        <h2 style={{ margin:'0 0 20px', fontFamily:"'Fraunces',serif", color:'#691FB1', fontSize:20 }}>{isNew?'Novo Projeto':'Editar Projeto'}</h2>
        <div style={{ display:'grid', gap:12 }}>
          <FRow label="Nome do projeto" value={form.name} onChange={v=>f('name',v)} placeholder="Ex: GL Galp 2026"/>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Cliente (conta-mae)</label>
              <select value={form.cliente_id||''} onChange={e=>{ const id=e.target.value; const cm=clientesN.find(x=>x.id===id); f('cliente_id',id||null); f('client',cm?cm.nome:''); f('local_id',null); }}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }}>
                <option value="">Seleccionar cliente...</option>
                {clientesN.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
              {form.cliente_id && locaisN.filter(l=>l.cliente_id===form.cliente_id).length>0 && (
                <select value={form.local_id||''} onChange={e=>f('local_id',e.target.value||null)}
                  style={{ width:'100%', marginTop:6, padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }}>
                  <option value="">- todo o cliente (sem local especifico) -</option>
                  {locaisN.filter(l=>l.cliente_id===form.cliente_id).map(l=><option key={l.id} value={l.id}>{l.nome}</option>)}
                </select>
              )}
            </div>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Tipo de projeto</label>
              <select value={form.project_type||'Standard'} onChange={e=>{ const t=e.target.value; setForm(p=>({ ...p, project_type:t,
                  marketing_projeto_id: ehEvento(t) ? (p.marketing_projeto_id || (eventoAtivo(eventosMkt, t)||{}).id || '') : '' })); }}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                {PROJECT_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
              </select>
              {ehEvento(form.project_type) && (<div style={{ marginTop:8 }}>
                <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>🎪 Evento no Marketing (edição)</label>
                <select value={form.marketing_projeto_id||''} onChange={e=>f('marketing_projeto_id', e.target.value)}
                  style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                  <option value="">— escolher —</option>
                  {eventosMkt.map(ev => <option key={ev.id} value={ev.id}>{ev.nome}{/conclu/i.test(ev.estado||'') ? ' (concluído)' : ''}</option>)}
                </select>
                <div style={{ fontSize:11, color:'#8888AA', marginTop:3 }}>O valor fica como receita prevista nesse evento até a fatura ser paga. Sem fases nem follow-ups automáticos.</div>
              </div>)}
            </div>
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Subprojeto de (conta-mãe) — opcional</label>
            {(() => {
              const maes = allProjects.filter(p => p.id!==form.id && p.is_mae);
              const selecionada = maes.find(m => m.id===form.parent_id);
              const q = buscaMae.trim().toLowerCase();
              const filtradas = q ? maes.filter(m => (m.name||'').toLowerCase().includes(q) || (m.client||'').toLowerCase().includes(q)) : maes;
              if (selecionada) return (
                <div style={{ display:'flex', alignItems:'center', gap:8, padding:'9px 11px', border:'1px solid #691FB1', borderRadius:7, background:'#F7F5FC' }}>
                  <span style={{ flex:1, fontSize:13, color:'#691FB1', fontWeight:600 }}>📦 {selecionada.name}{selecionada.client?' · '+selecionada.client:''}</span>
                  <button type="button" onClick={()=>{ f('parent_id',null); setBuscaMae(''); }} style={{ background:'none', border:'none', color:'#8888AA', cursor:'pointer', fontSize:16 }}>✕</button>
                </div>
              );
              return (
                <div>
                  <input value={buscaMae} onChange={e=>setBuscaMae(e.target.value)} placeholder="Escreve o nome do cliente ou projeto-mãe…"
                    style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }}/>
                  {q && (
                    <div style={{ marginTop:4, maxHeight:180, overflowY:'auto', border:'1px solid #E4DEFA', borderRadius:7 }}>
                      {filtradas.length===0 && <div style={{ padding:'8px 11px', fontSize:12, color:'#8888AA', fontStyle:'italic' }}>Nenhum projeto-mãe encontrado.</div>}
                      {filtradas.map(m => (
                        <div key={m.id} onClick={()=>{ f('parent_id',m.id); setBuscaMae(''); }}
                          style={{ padding:'8px 11px', fontSize:13, cursor:'pointer', borderBottom:'1px solid #F0ECFA' }}
                          onMouseEnter={e=>e.currentTarget.style.background='#F7F5FC'}
                          onMouseLeave={e=>e.currentTarget.style.background='white'}>
                          📦 {m.name}{m.client?<span style={{ color:'#8888AA' }}> · {m.client}</span>:''}
                        </div>
                      ))}
                    </div>
                  )}
                  {!q && <p style={{ fontSize:11, color:'#8888AA', margin:'4px 0 0' }}>Só aparecem projetos marcados como conta-mãe. Deixa vazio se este não é subprojeto.</p>}
                </div>
              );
            })()}
            {form.parent_id && <p style={{ fontSize:11, color:'#8888AA', margin:'5px 0 0' }}>Este projeto entra como subprojeto, com a sua propria linha de negocio e faturacao.</p>}
          </div>
          {!form.parent_id && (
            <div style={{ background:form.is_mae?'#EDE7F6':'#FAFAFF', border:`1px solid ${form.is_mae?'#691FB1':'#E4DEFA'}`, borderRadius:9, padding:'12px 14px' }}>
              <label style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}>
                <input type="checkbox" checked={!!form.is_mae} onChange={e=>f('is_mae', e.target.checked)} style={{ width:18, height:18, accentColor:'#691FB1', cursor:'pointer' }}/>
                <span style={{ fontSize:13, fontWeight:700, color:'#691FB1' }}>📦 Programa-mae (agrupa subprojetos)</span>
              </label>
              {form.is_mae && <p style={{ fontSize:11, color:'#8888AA', margin:'8px 0 0', lineHeight:1.5 }}>Nao sao criadas fases automaticas. <strong>Valor opcional:</strong> preenche so se o cliente paga um valor global ao programa; caso contrario deixa vazio e a faturacao vem dos subprojetos.</p>}
            </div>
          )}
          {isNew&&form.project_type&&TEMPLATES[form.project_type]&&(
            <div style={{ background:'#EDE7F6', borderRadius:8, padding:'10px 14px', fontSize:12, color:'#691FB1' }}>
              📋 <strong>Template {form.project_type}</strong> — {TEMPLATES[form.project_type].length} fases criadas automaticamente:
              <div style={{ marginTop:6, display:'flex', flexWrap:'wrap', gap:5 }}>
                {TEMPLATES[form.project_type].map((t,i)=>(
                  <span key={i} style={{ background:'white', borderRadius:5, padding:'2px 8px', fontSize:11, border:'1px solid #C6C3E7' }}>
                    {i+1}. {t.nome} <span style={{ color:'#8888AA' }}>({ehFaseExecucao(t.nome) ? (form.contract_start && form.contract_end && form.contract_end >= form.contract_start ? `${Math.round((new Date(form.contract_end) - new Date(form.contract_start)) / 864e5)}d — o contrato` : 'duração do contrato') : `${t.dias}d`})</span>
                  </span>
                ))}
              </div>
            </div>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Estado</label>
              <select value={form.status||'Em proposta'} onChange={e=>f('status',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                {Object.keys(PROJECT_STATES).map(s=><option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            {!ehMaeComFilhos && <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Modelo de faturação</label>
              <select value={form.billing_model||'Mensal fixo'} onChange={e=>f('billing_model',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                {BILLING_MODELS.map(b=><option key={b} value={b}>{b}</option>)}
              </select>
            </div>}
            {/* Entidades que faturam este projeto. Uma: vai inteiro para ela. Várias: cada uma
                assume uma % ou um valor fixo (o mesmo projeto, a fatura é que se divide). */}
            {(() => {
              const cid = form.cliente_id || (clientesN.find(x=>x.nome===form.client)||{}).id;
              const minhas = entidades.filter(e => e.cliente_id === cid);
              if (!cid || minhas.length === 0) return null;
              const rep = Array.isArray(form.repart) ? form.repart : [];
              const setRep = (r) => setForm(p => ({ ...p, repart: r, entidade_faturacao_id: r.length === 1 ? r[0].entidade_id : null }));
              const linhaDe = (id) => rep.find(r => r.entidade_id === id);
              const toggle = (id) => setRep(linhaDe(id) ? rep.filter(r => r.entidade_id !== id) : [...rep, { entidade_id: id, tipo: 'percentagem', valor: '' }]);
              const upd = (id, k, v) => setRep(rep.map(r => r.entidade_id === id ? { ...r, [k]: v } : r));
              const varias = rep.length >= 2;
              const somaPct = rep.filter(r => r.tipo !== 'fixo').reduce((a, r) => a + (Number(String(r.valor).replace(',', '.')) || 0), 0);
              const temVazio = rep.some(r => r.valor === '' || r.valor == null);
              return (
                <div style={{ gridColumn:'1 / -1' }}>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>
                    Entidade(s) que faturam <span style={{ fontWeight:400 }}>· nenhuma marcada = a do cliente</span></label>
                  <div style={{ border:'1px solid #E4DEFA', borderRadius:7, padding:'4px 0', background:'#fff' }}>
                    {minhas.map(e => { const l = linhaDe(e.id); return (
                      <div key={e.id} style={{ display:'flex', alignItems:'center', gap:8, padding:'5px 10px', fontSize:12.5, background: l ? '#F4F1FB' : 'transparent' }}>
                        <input type="checkbox" checked={!!l} onChange={()=>toggle(e.id)} style={{ accentColor:'#691FB1', cursor:'pointer' }}/>
                        <span style={{ flex:1 }}>{e.designacao_fiscal}{e.nif?<span style={{ color:'#8888AA' }}> · {e.nif}</span>:null}</span>
                        {l && varias && (<>
                          <select value={l.tipo} onChange={ev=>upd(e.id,'tipo',ev.target.value)} style={{ padding:'4px 6px', border:'1px solid #E4DEFA', borderRadius:6, fontSize:12 }}>
                            <option value="percentagem">%</option><option value="fixo">€ fixo</option>
                          </select>
                          <input value={l.valor} onChange={ev=>upd(e.id,'valor',ev.target.value)} placeholder={l.tipo==='fixo'?'€':'%'}
                            style={{ width:70, padding:'4px 6px', border:'1px solid #E4DEFA', borderRadius:6, fontSize:12, textAlign:'right' }}/>
                        </>)}
                      </div>); })}
                  </div>
                  {varias && (
                    <div style={{ fontSize:11, color: (!temVazio && rep.every(r=>r.tipo!=='fixo') && Math.abs(somaPct-100)>0.01) ? '#C0392B' : '#8888AA', marginTop:4, lineHeight:1.5 }}>
                      O valor fixo sai primeiro; as percentagens aplicam-se ao resto. Uma entidade sem valor fica com o que sobrar.
                      {rep.every(r=>r.tipo!=='fixo') && !temVazio && <> · soma das %: <strong>{somaPct.toLocaleString('pt-PT')}%</strong></>}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Nota de encomenda — os POs são do cliente e podem cobrir vários
                projetos, por isso escolhem-se de uma lista em vez de escritos. */}
            {(() => {
              const cid = form.cliente_id || (clientesN.find(x=>x.nome===form.client)||{}).id;
              const meus = pos.filter(p => p.cliente_id === cid && p.estado !== 'Inativo');
              if (!cid) return null;
              const escolhido = meus.find(p => p.id === form.po_id);
              return (
                <div>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Nota de encomenda (PO)</label>
                  {meus.length === 0 ? (
                    <div style={{ fontSize:11.5, color:'#8888AA', padding:'8px 0', lineHeight:1.5 }}>
                      Este cliente não tem POs registados. Cria em Definições › Clientes.
                    </div>
                  ) : (
                    <>
                      <select value={form.po_id||''} onChange={e=>f('po_id', e.target.value||null)}
                        style={{ width:'100%', padding:'8px 10px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box', background:'#fff' }}>
                        <option value="">— sem PO —</option>
                        {meus.map(p=>(
                          <option key={p.id} value={p.id}>
                            {p.numero}{p.valor!=null ? ` · ${Number(p.disponivel).toLocaleString('pt-PT',{minimumFractionDigits:2})}€ disponíveis` : ''}{p.validade ? ` · até ${p.validade}` : ''}
                          </option>
                        ))}
                      </select>
                      {escolhido && ['Esgotado','Expirado','A esgotar','A expirar'].includes(escolhido.estado) && (
                        <div style={{ fontSize:11, marginTop:4, color: escolhido.estado.startsWith('A ') ? '#B9770E' : '#C0392B' }}>
                          Este PO está {escolhido.estado.toLowerCase()}.
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })()}

            {/* Quem recebe a fatura deste projeto, quando é diferente do contacto
                da entidade — quem gere a formação não é quem gere o programa. */}
            {(form.cliente_id || form.client) && (
              <div style={{ gridColumn:'1 / -1', display:'flex', gap:10, flexWrap:'wrap' }}>
                <div style={{ flex:1, minWidth:180 }}>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Contacto de faturação deste projeto <span style={{ fontWeight:400 }}>· opcional</span></label>
                  <input value={form.fat_contacto_nome||''} placeholder="nome — deixa vazio para usar o da entidade"
                    onChange={e=>f('fat_contacto_nome', e.target.value)}
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }}/>
                </div>
                <div style={{ flex:1, minWidth:180 }}>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Email</label>
                  <input value={form.fat_contacto_email||''} type="email" placeholder="email de quem recebe a fatura"
                    onChange={e=>f('fat_contacto_email', e.target.value)}
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }}/>
                </div>
              </div>
            )}

            {form.billing_model==='Mensal fixo'&&<div style={{ gridColumn:'1 / -1' }}>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Meses SEM faturação (serviço em pausa — vale para todos os anos)</label>
              <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                {['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'].map((m,i)=>{
                  const num=i+1; const sel=(form.meses_pausa||[]).includes(num);
                  return (
                    <button key={m} type="button"
                      onClick={()=>f('meses_pausa', sel?(form.meses_pausa||[]).filter(x=>x!==num):[...(form.meses_pausa||[]),num].sort((a,b)=>a-b))}
                      style={{ padding:'5px 10px', borderRadius:14, border:`1.5px solid ${sel?'#E67E22':'#E4DEFA'}`, background:sel?'#FEF5E7':'#fff', color:sel?'#E67E22':'#8888AA', fontSize:12, fontWeight:sel?700:400, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                      {sel?'⏸ ':''}{m}
                    </button>
                  );
                })}
              </div>
              {(form.meses_pausa||[]).length>0&&<div style={{ fontSize:11, color:'#E67E22', marginTop:5 }}>Nestes meses o Financeiro não considera este serviço para faturação.</div>}
            </div>}
            {['Pré-pago','Único','Por marco'].includes(form.billing_model)&&(()=>{
              const plano = Array.isArray(form.plano_faturacao) ? form.plano_faturacao : [];
              const setPlano = (pl) => f('plano_faturacao', pl);
              const mesAntes = (ym) => { if(!ym) return ''; const [y,m]=ym.split('-').map(Number); const d=new Date(y,m-2,1); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0'); };
              const ini = (form.contract_start||'').slice(0,7);
              const total = Number(form.value)||0;
              const soma = plano.reduce((a,t)=>a+(t.tipo==='fixo'?(Number(t.valor)||0):total*(Number(t.valor)||0)/100),0);
              const inp = { padding:'6px 8px', border:'1px solid #E4DEFA', borderRadius:6, fontSize:12.5, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' };
              return (
              <div style={{ gridColumn:'1 / -1' }}>
                {plano.length === 0 ? (<>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Mês de faturação <span style={{ fontWeight:400 }}>· vazio = mês de início do contrato</span></label>
                  <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                    <input type="month" value={form.billing_month||''} onChange={e=>f('billing_month',e.target.value)} style={{ ...inp, padding:'9px 11px', fontSize:13 }}/>
                    <button type="button" onClick={()=>setPlano([{ mes:mesAntes(ini)||'', tipo:'percentagem', valor:50 },{ mes:ini||'', tipo:'percentagem', valor:50 }])}
                      style={{ background:'#F4F1FB', border:'1px solid #E4DEFA', color:'#691FB1', borderRadius:7, padding:'7px 11px', fontSize:12, cursor:'pointer', fontWeight:600 }}>Faturar em tranches (ex.: 50% antes + 50% no mês)</button>
                  </div>
                </>) : (<>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Faturação em tranches</label>
                  {plano.map((t,i)=>(
                    <div key={i} style={{ display:'flex', gap:6, alignItems:'center', marginBottom:5 }}>
                      <span style={{ fontSize:11.5, color:'#8888AA', width:58 }}>Tranche {i+1}</span>
                      <input type="month" value={t.mes||''} onChange={e=>setPlano(plano.map((x,j)=>j===i?{...x,mes:e.target.value}:x))} style={inp}/>
                      <select value={t.tipo||'percentagem'} onChange={e=>setPlano(plano.map((x,j)=>j===i?{...x,tipo:e.target.value}:x))} style={inp}>
                        <option value="percentagem">%</option><option value="fixo">€</option>
                      </select>
                      <input value={t.valor??''} onChange={e=>setPlano(plano.map((x,j)=>j===i?{...x,valor:e.target.value}:x))} style={{ ...inp, width:80, textAlign:'right' }}/>
                      <span style={{ fontSize:11.5, color:'#4A4A6A', minWidth:70, textAlign:'right' }}>{(t.tipo==='fixo'?(Number(t.valor)||0):total*(Number(t.valor)||0)/100).toLocaleString('pt-PT',{minimumFractionDigits:2})}€</span>
                      <button type="button" onClick={()=>setPlano(plano.filter((_,j)=>j!==i))} style={{ background:'none', border:'none', color:'#C0392B', cursor:'pointer', fontSize:14 }}>×</button>
                    </div>))}
                  <div style={{ display:'flex', gap:12, alignItems:'center', fontSize:11.5, marginTop:2 }}>
                    <button type="button" onClick={()=>setPlano([...plano,{ mes:'', tipo:'percentagem', valor:'' }])} style={{ background:'none', border:'none', color:'#691FB1', cursor:'pointer', padding:0, fontWeight:600 }}>+ tranche</button>
                    <button type="button" onClick={()=>setPlano([])} style={{ background:'none', border:'none', color:'#8888AA', cursor:'pointer', padding:0 }}>faturar de uma vez</button>
                    <span style={{ marginLeft:'auto', color: Math.abs(soma-total)>0.01 ? '#C0392B' : '#1E8449', fontWeight:700 }}>
                      {soma.toLocaleString('pt-PT',{minimumFractionDigits:2})}€ de {total.toLocaleString('pt-PT',{minimumFractionDigits:2})}€</span>
                  </div>
                </>)}
              </div>);
            })()}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Responsável Operações</label>
              <select value={form.owner_email||''} onChange={e=>{const u=users.find(u=>u.email===e.target.value);f('owner_email',e.target.value);f('owner_name',u?.full_name||'');}}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                <option value="">Sem responsável</option>
                {users.map(u=><option key={u.email} value={u.email}>{u.full_name} ({u.role==='admin'?'Admin':u.role==='tl'?'TL':'Op.'})</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Comercial</label>
              <select value={form.commercial_email||''} onChange={e=>{const u=users.find(u=>u.email===e.target.value);f('commercial_email',e.target.value);f('commercial_name',u?.full_name||'');}}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none' }}>
                <option value="">Sem comercial</option>
                {users.map(u=><option key={u.email} value={u.email}>{u.full_name}</option>)}
              </select>
            </div>
          </div>
          <div style={{ background:'#F7F5FC', borderRadius:9, padding:14 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#8888AA', textTransform:'uppercase', letterSpacing:0.8, marginBottom:10 }}>📋 Contrato</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10 }}>
              <FRow label="Início" type="date" value={form.contract_start} onChange={v=>f('contract_start',v)}/>
              <FRow label="Fim" type="date" value={form.contract_end} onChange={v=>f('contract_end',v)}/>
              {ehMaeComFilhos ? (
                <div>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Valor dos projetos</label>
                  <div style={{ padding:'9px 11px', background:'#EDE7F6', borderRadius:7, fontSize:13, color:'#691FB1', fontWeight:700 }}>
                    {somaFilhos.toLocaleString('pt-PT',{minimumFractionDigits:2})}€
                  </div>
                </div>
              ) : (
                form.project_type==='Evento' ? (
                <div>
                  <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Valor total (€) <span style={{ fontWeight:400 }}>· soma das linhas</span></label>
                  <div style={{ padding:'9px 11px', background:'#EDE7F6', borderRadius:7, fontSize:13, color:'#691FB1', fontWeight:700 }}>
                    {((Array.isArray(form.linhas_faturacao)&&form.linhas_faturacao.length) ? form.linhas_faturacao.reduce((a,l)=>a+(Number(String(l.qtd??'').replace(',','.'))||1)*(Number(String(l.preco_unit??'').replace(',','.'))||0),0) : (Number(form.value)||0)).toLocaleString('pt-PT',{minimumFractionDigits:2})}€
                  </div>
                </div>
                ) : (
                <FRow label="Valor total (€)" type="number" value={form.value} onChange={v=>f('value',v)} placeholder="0"/>
                )
              )}
            </div>
            {ehMaeComFilhos && (
              <div style={{ marginTop:9, fontSize:11.5, color:'#4A4A6A', background:'#FAF8FF', borderRadius:7, padding:'9px 11px', lineHeight:1.55 }}>
                Este é um programa-mãe com {filhos.length} projeto{filhos.length>1?'s':''}. O valor e o modelo
                de faturação ficam em cada um deles — aqui mostra-se a soma, para não contar duas vezes.
              </div>
            )}
            {contractDays&&contractDays>0&&(
              <div style={{ marginTop:10, fontSize:12, color:'#691FB1', fontWeight:600 }}>
                📅 Duração: <strong>{contractDays} dias</strong> ({Math.round(contractDays/30)} meses)
                <span style={{ fontSize:11, color:'#8888AA', fontWeight:400, marginLeft:8 }}>· Alertas aos 90, 60 e 30 dias do fim</span>
              </div>
            )}
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Áreas de negócio <span style={{ fontWeight:400, fontSize:10 }}>(pode escolher várias)</span></label>
            <div style={{ display:'flex', gap:10 }}>
              {LINHAS.map(area=>{ const arr=Array.isArray(form.business_areas)?form.business_areas:[]; const sel=arr.includes(area); const cor=LINHA_COR[area]||'#8888AA'; return (
                <button key={area} type="button" onClick={()=>{ const s=new Set(arr); s.has(area)?s.delete(area):s.add(area); f('business_areas',[...s]); }}
                  style={{ flex:1, padding:'10px', border:`2px solid ${sel?cor:'#E4DEFA'}`, borderRadius:8, background:sel?cor+'22':'white', color:sel?cor:'#8888AA', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:sel?700:400 }}>
                  {sel?'✓ ':''}{LINHA_ICON[area]||''} {area}
                </button>
              ); })}
            </div>
          </div>
          {form.project_type!=='Evento' && <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Código de faturação <span style={{ fontWeight:400 }}>· nomenclatura que sai na fatura</span></label>
            <select value={form.servico_codigo||''} onChange={e=>{ const cod=e.target.value||null; f('servico_codigo',cod);
                const sv=(servicosCat||[]).find(x=>x.codigo===cod);
                if(sv&&sv.linha&&!(Array.isArray(form.business_areas)&&form.business_areas.includes(sv.linha))) f('business_areas',[...(Array.isArray(form.business_areas)?form.business_areas:[]),sv.linha]); }}
              style={{ width:'100%', padding:'8px 10px', border:'1px solid #E5E3F0', borderRadius:7, fontSize:13, boxSizing:'border-box' }}>
              <option value="">— sem código —</option>
              {(servicosCat||[]).filter(x=>x.codigo && (x.ativo!==false || x.codigo===form.servico_codigo)).map(x=><option key={x.codigo} value={x.codigo}>{x.codigo} · {x.nome}{x.linha?` (${x.linha})`:''}{x.ativo===false?' — inativo':''}</option>)}
            </select>
          </div>}
          {!ehMaeComFilhos && (form.project_type==='Evento' || (Array.isArray(form.linhas_faturacao) && form.linhas_faturacao.length>0)) && (()=>{
            // Só nos projetos do tipo Evento: várias linhas de faturação no mesmo projeto (ex.: um evento com Quickmassage + Workshop + Smoothie bike).
            // Quando há linhas, o valor do projeto passa a ser a soma delas e o Financeiro mostra cada linha com o seu código.
            const ls = Array.isArray(form.linhas_faturacao) && form.linhas_faturacao.length ? form.linhas_faturacao
              : [{ codigo: form.servico_codigo || null, descricao: ((servicosCat||[]).find(x=>x.codigo===form.servico_codigo)||{}).nome || '', qtd: 1, preco_unit: form.value || '' }];
            const usados = new Set(ls.map(l=>l.codigo).filter(Boolean)); const grupos = {}; (servicosCat||[]).filter(x=>x.codigo && (x.ativo!==false || usados.has(x.codigo))).forEach(x=>{ const L=x.linha||'Outros'; (grupos[L]=grupos[L]||[]).push(x); });
            const setLs = (v) => f('linhas_faturacao', v);
            const num = (x) => Number(String(x??'').replace(',','.')) || 0;
            const tot = ls.reduce((a,l)=>a+(num(l.qtd)||1)*num(l.preco_unit),0);
            const inp = { padding:'6px 8px', border:'1px solid #E4DEFA', borderRadius:6, fontSize:12.5, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box', minWidth:0 };
            return (
            <div style={{ gridColumn:'1 / -1' }}>
              <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>
                Linhas de faturação do evento <span style={{ fontWeight:400 }}>· um serviço por linha, com o seu código</span>
              </label>
              {ls.map((l,i)=>(
                <div key={i} style={{ display:'grid', gridTemplateColumns:'minmax(140px,1.4fr) minmax(120px,1.6fr) 56px 84px 80px 24px', gap:6, alignItems:'center', marginBottom:5 }}>
                  <select value={l.codigo||''} onChange={e=>{ const cod=e.target.value||null; const sv=(servicosCat||[]).find(x=>x.codigo===cod);
                      setLs(ls.map((x,j)=>j===i?{...x, codigo:cod, descricao: x.descricao || (sv?sv.nome:'')}:x)); }} style={inp}>
                    <option value="">— escolher serviço —</option>
                    {Object.entries(grupos).map(([L,arr])=>(
                      <optgroup key={L} label={L}>
                        {arr.map(x=><option key={x.codigo} value={x.codigo}>{x.nome} ({x.codigo})</option>)}
                      </optgroup>))}
                  </select>
                  <input value={l.descricao||''} placeholder="Descrição (sai na fatura)" onChange={e=>setLs(ls.map((x,j)=>j===i?{...x,descricao:e.target.value}:x))} style={inp}/>
                  <input value={l.qtd??''} placeholder="Qtd" onChange={e=>setLs(ls.map((x,j)=>j===i?{...x,qtd:e.target.value}:x))} style={{ ...inp, textAlign:'right' }}/>
                  <input value={l.preco_unit??''} placeholder="Preço €" onChange={e=>setLs(ls.map((x,j)=>j===i?{...x,preco_unit:e.target.value}:x))} style={{ ...inp, textAlign:'right' }}/>
                  <span style={{ fontSize:12, textAlign:'right', color:'#4A4A6A' }}>{((num(l.qtd)||1)*num(l.preco_unit)).toLocaleString('pt-PT',{minimumFractionDigits:2})}€</span>
                  <button type="button" onClick={()=>setLs(ls.filter((_,j)=>j!==i))} title="Tirar linha"
                    style={{ background:'none', border:'none', color:'#C0392B', cursor:'pointer', fontSize:15 }}>×</button>
                </div>))}
              <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:4, flexWrap:'wrap' }}>
                <button type="button" onClick={()=>setLs([...ls, { codigo:null, descricao:'', qtd:1, preco_unit:'' }])}
                  style={{ background:'#F4F1FB', border:'1px solid #E4DEFA', color:'#691FB1', borderRadius:7, padding:'6px 11px', fontSize:12, cursor:'pointer', fontWeight:600 }}>+ Linha de faturação</button>
                {ls.length>0 && <span style={{ fontSize:12, color:'#4A4A6A' }}>Total do projeto: <strong>{tot.toLocaleString('pt-PT',{minimumFractionDigits:2})}€</strong> <span style={{ color:'#8888AA' }}>· passa a ser o Valor ao guardar</span></span>}
              </div>
            </div>);
          })()}
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Serviços que este projeto vende</label>
            <div style={{ fontSize:10.5, color:'#8888AA', marginBottom:6, lineHeight:1.5 }}>
              É por aqui que as sessões do calendário são atribuídas a este projeto.
              Sem isto, contam em todos os projetos do cliente.
            </div>
            {(() => {
              const sel = Array.isArray(form.servicos) ? form.servicos : [];
              const toggle = (nome) => { const s=new Set(sel); s.has(nome)?s.delete(nome):s.add(nome); f('servicos',[...s]); };
              // O catálogo novo agrupa por área: no Vitality são famílias de
              // serviço, no Mind são os planos. É este nível que o projeto vende,
              // e é por ele que as sessões lhe são atribuídas.
              const fonte = (catServicos && catServicos.length) ? catServicos : (servicosCat||[]).map(s=>({area:s.linha||'Outros', nome:s.nome}));
              const porLinha = {};
              fonte.forEach(sv => { const L=sv.area||'Outros'; (porLinha[L]=porLinha[L]||[]).push(sv.nome); });
              const linhas = Object.keys(porLinha);
              if (linhas.length===0) return <div style={{ fontSize:12, color:'#8888AA', fontStyle:'italic' }}>Sem catálogo de serviços disponível.</div>;
              return (
                <div style={{ border:'1px solid #E4DEFA', borderRadius:8, padding:'8px 10px', maxHeight:180, overflowY:'auto' }}>
                  {sel.length>0 && <div style={{ fontSize:11, color:'#691FB1', fontWeight:600, marginBottom:6 }}>{sel.length} selecionado(s)</div>}
                  {linhas.map(L => (
                    <div key={L} style={{ marginBottom:6 }}>
                      <div style={{ fontSize:10, fontWeight:700, color:'#8888AA', textTransform:'uppercase', margin:'4px 0' }}>{L}</div>
                      <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                        {porLinha[L].map(nome => { const on=sel.includes(nome); return (
                          <button key={nome} type="button" onClick={()=>toggle(nome)}
                            style={{ padding:'4px 10px', borderRadius:20, border:`1px solid ${on?'#691FB1':'#E4DEFA'}`, background:on?'#691FB122':'white', color:on?'#691FB1':'#666', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:on?600:400 }}>
                            {on?'✓ ':''}{nome}
                          </button>
                        ); })}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>Tipo de negócio</label>
            <div style={{ display:'flex', gap:10 }}>
              {[['Novo','#27AE60'],['Retenção','#1A6FA0'],['Upsell','#691FB1'],['Cross','#FF357B']].map(([tn,cor])=>{ const sel=(form.tipo_negocio||'Novo')===tn; return (
                <button key={tn} type="button" onClick={()=>f('tipo_negocio',tn)}
                  style={{ flex:1, padding:'10px', border:`2px solid ${sel?cor:'#E4DEFA'}`, borderRadius:8, background:sel?cor+'22':'white', color:sel?cor:'#8888AA', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:sel?700:400 }}>
                  {tn}
                </button>
              ); })}
            </div>
          </div>
          {perms?.canEditCommercial && (<>
          <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', padding:'8px 0' }}>
            <input type="checkbox" checked={!!form.sem_comissao} onChange={e=>f('sem_comissao', e.target.checked)} style={{ width:18, height:18, accentColor:'#691FB1', cursor:'pointer' }}/>
            <span style={{ fontSize:12, color:'#4A4A6A', fontWeight:600 }}>Sem comissao (projeto de margem curta)</span>
          </label>
          {form.sem_comissao && (
            <input value={form.comissao_nota||''} onChange={e=>f('comissao_nota', e.target.value)}
              placeholder="Porque nao ha comissao? (ex.: comercial abdicou, acordado em 19/08)"
              style={{ width:'100%', padding:'8px 11px', border:'1px solid #E4DEFA', borderRadius:8,
                fontSize:12, fontFamily:"'DM Sans',sans-serif", marginBottom:8, boxSizing:'border-box' }}/>
          )}

          {/* COMISSAO FIXA — substitui a percentagem quando preenchida */}
          <div style={{ border:'1px solid #E4DEFA', borderRadius:9, padding:'11px 14px', marginBottom:9,
            background: Number(form.comissao_fixa)>0 ? '#EDE7F6' : '#FAFAFF' }}>
            <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
              <span style={{ fontSize:12, fontWeight:700, color:'#691FB1' }}>Comissao fixa</span>
              <input type="number" step="0.01" value={form.comissao_fixa ?? ''}
                onChange={e=>f('comissao_fixa', e.target.value===''?null:e.target.value)}
                placeholder="ex.: 250"
                style={{ width:110, padding:'7px 10px', border:'1px solid #E4DEFA', borderRadius:7,
                  fontSize:13, fontFamily:"'DM Sans',sans-serif" }}/>
              <span style={{ fontSize:11, color:'#8888AA' }}>
                {Number(form.comissao_fixa)>0
                  ? 'Substitui a percentagem. Paga uma vez, no primeiro mes com faturacao.'
                  : 'Deixar vazio para usar a percentagem do tipo de negocio.'}
              </span>
            </div>
            {Number(form.comissao_fixa)>0 && (
              <input value={form.comissao_fixa_nota||''} onChange={e=>f('comissao_fixa_nota', e.target.value)}
                placeholder="Com quem foi acordado e quando"
                style={{ width:'100%', padding:'7px 10px', border:'1px solid #E4DEFA', borderRadius:7,
                  fontSize:12, fontFamily:"'DM Sans',sans-serif", marginTop:8, boxSizing:'border-box' }}/>
            )}
          </div>
          {(()=>{
            const somaDecomp=(Number(form.comissao_retencao)||0)+(Number(form.comissao_upsell)||0)+(Number(form.comissao_novo)||0)+(Number(form.comissao_cross)||0);
            const valor=Number(form.value)||0;
            const temDecomp=somaDecomp>0;
            const bate=valor>0 && Math.abs(somaDecomp-valor)<0.01;
            return (
              <div style={{ border:'1px solid #E4DEFA', borderRadius:9, overflow:'hidden' }}>
                <button type="button" onClick={()=>f('_showDecomp', !form._showDecomp)}
                  style={{ width:'100%', textAlign:'left', background:temDecomp?'#EDE7F6':'#FAFAFF', border:'none', padding:'10px 14px', fontSize:12, fontWeight:700, color:'#691FB1', cursor:'pointer', fontFamily:"'DM Sans',sans-serif", display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span>{(form._showDecomp||temDecomp)?'▾':'▸'} Decomposicao para comissao (opcional){temDecomp?` · ${somaDecomp.toLocaleString('pt-PT')}€`:''}</span>
                </button>
                {(form._showDecomp||temDecomp) && (
                  <div style={{ padding:'12px 14px', display:'flex', flexDirection:'column', gap:10 }}>
                    <p style={{ fontSize:11, color:'#8888AA', margin:0, lineHeight:1.5 }}>Preenche so em renovacoes com aumento ou negocios mistos (ex: 1000 Retencao + 100 Upsell). Senao deixa vazio e usa-se o Tipo de negocio acima.</p>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:8 }}>
                      <FRow label="Retencao" type="number" value={form.comissao_retencao} onChange={v=>f('comissao_retencao',v)} placeholder="0"/>
                      <FRow label="Upsell" type="number" value={form.comissao_upsell} onChange={v=>f('comissao_upsell',v)} placeholder="0"/>
                      <FRow label="Novo" type="number" value={form.comissao_novo} onChange={v=>f('comissao_novo',v)} placeholder="0"/>
                      <FRow label="Cross" type="number" value={form.comissao_cross} onChange={v=>f('comissao_cross',v)} placeholder="0"/>
                    </div>
                    {temDecomp && (
                      bate
                        ? <div style={{ fontSize:11, color:'#1E8449', fontWeight:600 }}>✓ Soma ({somaDecomp.toLocaleString('pt-PT')}€) bate com o valor do projeto.</div>
                        : <div style={{ fontSize:11, color:'#C0392B', fontWeight:600 }}>⚠ Soma ({somaDecomp.toLocaleString('pt-PT')}€) ≠ valor do projeto ({valor.toLocaleString('pt-PT')}€). Verifica.</div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}
          </>)}
          {isNew ? (<>
            <FRow label="Descrição / Briefing" value={form.description} onChange={v=>f('description',v)} placeholder="Contexto do projeto..."/>
            <FRow label="Notas internas" value={form.notes} onChange={v=>f('notes',v)} placeholder="Observações internas..."/>
          </>) : (<>
            <AcoesDoProjeto projeto={item} userEmail={autor} userName={autor} destaque={item.project_type==='Formação'}/>
            <ProjectNotas projectId={item.id} tipo="descricao" titulo="Descrição / Briefing" autor={autor} autorEmail={autorEmail} nomeProjeto={item.name}/>
            <ProjectNotas projectId={item.id} tipo="nota" titulo="Notas internas" autor={autor} autorEmail={autorEmail} nomeProjeto={item.name}/>
            {/* Notas de faturação: o financeiro é avisado por email assim que uma é escrita */}
            <div style={{ background:'#FAF8FF', border:'1px solid #E4DEFA', borderRadius:9, padding:'12px 14px', marginBottom:14 }}>
              <ProjectNotas projectId={item.id} tipo="faturacao" titulo="💶 Notas de faturação"
                autor={autor} autorEmail={autorEmail} projeto={item.name} cliente={item.client}
                clienteId={item.cliente_id} notificarFinanceiro/>
              <div style={{ fontSize:10.5, color:C.textLight, marginTop:-6 }}>
                Condições acordadas, valores, prazos ou tudo o que o financeiro precise de saber para faturar.
                É enviado email para financeiro@workwell.pt assim que gravas.
              </div>
            </div>
            <ProjetoHistorico projectId={item.id}/>
            <div style={{ marginTop:14, borderTop:`1px solid ${C.border}`, paddingTop:12, fontSize:11, color:C.textLight }}>
              📎 Documentos, mapas de agendamento e portal do cliente passaram para <strong>Contas › Clientes</strong>.
            </div>
          </>)}
        </div>
        <div style={{ display:'flex', gap:10, marginTop:20 }}>
          <button onClick={onClose} style={{ flex:1, padding:10, border:'1px solid #E4DEFA', borderRadius:8, background:'#FFFFFF', color:'#4A4A6A', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
          <button onClick={()=>onSave({...form,
            value: ehMaeComFilhos ? null : ((Array.isArray(form.linhas_faturacao) && form.linhas_faturacao.some(l=>Number(String(l.preco_unit).replace(',','.'))>0))
                     ? Math.round(form.linhas_faturacao.reduce((a,l)=>a+(Number(String(l.qtd).replace(',','.'))||1)*(Number(String(l.preco_unit).replace(',','.'))||0),0)*100)/100
                     : (Number(form.value)||null)),
            billing_model: ehMaeComFilhos ? null : form.billing_model,
            parent_id:form.parent_id||null, is_mae:form.is_mae||false, tipo_negocio:form.tipo_negocio||null, sem_comissao:form.sem_comissao||false, comissao_retencao:form.comissao_retencao, comissao_upsell:form.comissao_upsell, comissao_novo:form.comissao_novo, comissao_cross:form.comissao_cross, comissao_fixa:form.comissao_fixa===''||form.comissao_fixa==null?null:Number(form.comissao_fixa), comissao_fixa_nota:form.comissao_fixa_nota||null, comissao_nota:form.comissao_nota||null, po_id:form.po_id||null, entidade_faturacao_id:form.entidade_faturacao_id||null, fat_contacto_nome:form.fat_contacto_nome||null, fat_contacto_email:form.fat_contacto_email||null, servico_codigo:(form.project_type==='Evento' && Array.isArray(form.linhas_faturacao) && form.linhas_faturacao.some(l=>l.codigo)) ? form.linhas_faturacao.find(l=>l.codigo).codigo : (form.servico_codigo || ((Array.isArray(form.linhas_faturacao) && (form.linhas_faturacao.find(l=>l.codigo)||{}).codigo) || null)),
            entidade_faturacao_id:form.entidade_faturacao_id||null,
            fat_contacto_nome:form.fat_contacto_nome||null, fat_contacto_email:form.fat_contacto_email||null, })}
            style={{ flex:2, padding:10, border:'none', borderRadius:8, background:'#691FB1', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
            {isNew?'Criar projeto':'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

function FRow({ label, type='text', value, onChange, placeholder }) {
  return (
    <div>
      <label style={{ fontSize:11, fontWeight:600, color:'#8888AA', display:'block', marginBottom:4 }}>{label}</label>
      <input type={type} value={value||''} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', padding:'9px 11px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }}/>
    </div>
  );
}

const CATS_CUSTO = ['Profissional','Deslocação','Alojamento','Materiais','Espaço','Produção','Catering','Licenças','Outros'];

function CustosModal({ project, canEdit, onClose }) {
  const [custos, setCustos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState('Profissional');
  const [desc, setDesc] = useState('');
  const [valor, setValor] = useState('');
  const [mes, setMes] = useState(()=>{ const d=new Date(); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0'); });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('custos_projeto').select('*').eq('projeto_id', project.id).order('created_at',{ascending:false});
    setCustos(data||[]);
    setLoading(false);
  };
  useEffect(()=>{ load(); /* eslint-disable-next-line */ }, [project.id]);

  const adicionar = async () => {
    const v = parseFloat(String(valor).replace(',','.'));
    if(!v || v<=0){ alert('Indica um valor válido.'); return; }
    setSaving(true);
    const { error } = await supabase.from('custos_projeto').insert({
      projeto_id: project.id,
      cliente_id: project.cliente_id || null,
      categoria: cat,
      descricao: desc || null,
      valor: Math.round(v*100)/100,
      mes,
    });
    setSaving(false);
    if(error){ alert('Erro ao gravar: '+error.message); return; }
    setDesc(''); setValor('');
    load();
  };

  const apagar = async (id) => {
    if(!window.confirm('Apagar este custo?')) return;
    await supabase.from('custos_projeto').delete().eq('id', id);
    load();
  };

  const total = custos.reduce((a,c)=>a+(Number(c.valor)||0),0);
  const valorProj = Number(project.value)||0;
  const margem = valorProj - total;
  const margemPct = valorProj>0 ? Math.round((margem/valorProj)*100) : null;

  const inp = { padding:'8px 10px', border:'1px solid #E4DEFA', borderRadius:7, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' };

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(20,10,40,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:14, width:'100%', maxWidth:640, maxHeight:'85vh', overflow:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ padding:'18px 22px', borderBottom:'1px solid #EEE9F9', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontSize:11, fontWeight:700, color:'#1E8449', textTransform:'uppercase', letterSpacing:0.8 }}>💰 Custos diretos</div>
            <div style={{ fontSize:17, fontWeight:700, color:C.purple, fontFamily:"'Fraunces',serif" }}>{project.name}</div>
          </div>
          <button onClick={onClose} style={{ background:'#F4F0FB', border:'none', borderRadius:8, width:32, height:32, cursor:'pointer', fontSize:16, color:C.purple }}>×</button>
        </div>

        {canEdit&&(
        <div style={{ padding:'16px 22px', background:'#FAFAFF', borderBottom:'1px solid #EEE9F9', display:'grid', gridTemplateColumns:'1.2fr 2fr 1fr 1.2fr auto', gap:8, alignItems:'end' }}>
          <div><div style={{ fontSize:10, color:'#888', fontWeight:600, marginBottom:3 }}>CATEGORIA</div>
            <select value={cat} onChange={e=>setCat(e.target.value)} style={{ ...inp, width:'100%' }}>{CATS_CUSTO.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
          <div><div style={{ fontSize:10, color:'#888', fontWeight:600, marginBottom:3 }}>DESCRIÇÃO</div>
            <input value={desc} onChange={e=>setDesc(e.target.value)} placeholder="opcional" style={{ ...inp, width:'100%' }}/></div>
          <div><div style={{ fontSize:10, color:'#888', fontWeight:600, marginBottom:3 }}>VALOR €</div>
            <input value={valor} onChange={e=>setValor(e.target.value)} placeholder="0,00" style={{ ...inp, width:'100%' }}/></div>
          <div><div style={{ fontSize:10, color:'#888', fontWeight:600, marginBottom:3 }}>MÊS</div>
            <input type="month" value={mes} onChange={e=>setMes(e.target.value)} style={{ ...inp, width:'100%' }}/></div>
          <button onClick={adicionar} disabled={saving} style={{ background:'#27AE60', border:'none', borderRadius:7, color:'#fff', padding:'9px 14px', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{saving?'...':'+ Add'}</button>
        </div>
        )}

        <div style={{ padding:'12px 22px' }}>
          {loading ? <div style={{ color:'#999', fontSize:13, padding:'12px 0' }}>A carregar…</div> :
           custos.length===0 ? <div style={{ color:'#999', fontSize:13, fontStyle:'italic', padding:'12px 0' }}>Sem custos registados.</div> :
           custos.map(c=>(
            <div key={c.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 0', borderBottom:'1px solid #F2EEFB' }}>
              <span style={{ fontSize:10, fontWeight:700, color:C.purple, background:'#EFE7FB', padding:'2px 8px', borderRadius:10, minWidth:80, textAlign:'center' }}>{c.categoria}</span>
              <span style={{ flex:1, fontSize:13, color:'#444' }}>{c.descricao||'—'}</span>
              <span style={{ fontSize:11, color:'#999' }}>{c.mes||''}</span>
              <span style={{ fontSize:13, fontWeight:700, color:'#C0392B', minWidth:80, textAlign:'right' }}>{(Number(c.valor)||0).toLocaleString('pt-PT')}€</span>
              {canEdit&&<button onClick={()=>apagar(c.id)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#C0392B' }}>🗑</button>}
            </div>
           ))}
        </div>

        <div style={{ padding:'14px 22px', borderTop:'1px solid #EEE9F9', background:'#FAFAFF' }}>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:5 }}><span style={{ color:'#666' }}>Faturação do projeto</span><strong style={{ color:C.purple }}>{valorProj.toLocaleString('pt-PT')}€</strong></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:5 }}><span style={{ color:'#666' }}>Total de custos</span><strong style={{ color:'#C0392B' }}>{total.toLocaleString('pt-PT')}€</strong></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:15, paddingTop:6, borderTop:'1px solid #EEE9F9' }}><span style={{ color:'#333', fontWeight:700 }}>Margem</span><strong style={{ color:margemPct!=null&&margemPct>=50?'#1E8449':'#E67E22', fontFamily:"'Fraunces',serif" }}>{margem.toLocaleString('pt-PT')}€{margemPct!=null?' ('+margemPct+'%)':''}</strong></div>
          {valorProj===0&&<div style={{ fontSize:11, color:'#999', marginTop:6, fontStyle:'italic' }}>Projeto sem valor fixo (ex. por sessão) — a margem só conta os custos aqui registados.</div>}
        </div>
      </div>
    </div>
  );
}


function ProjectAgendas({ projectId, autor, podeEditar }) {
  const [agendas, setAgendas] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [nova, setNova] = useState(null);
  const [slotsDe, setSlotsDe] = useState(null);      // agenda_id aberta
  const [slots, setSlots] = useState([]);
  const [msg, setMsg] = useState('');

  const carregar = React.useCallback(async ()=>{
    const { data } = await supabase.from('agendas').select('*').eq('project_id', projectId).order('data',{ascending:false});
    setAgendas(data||[]);
  },[projectId]);
  useEffect(()=>{ carregar(); },[carregar]);

  const hm = (s)=>{ const m=/^(\d{1,2}):(\d{2})/.exec(String(s||'')); return m? (+m[1])*60 + (+m[2]) : null; };
  const mh = (n)=>`${String(Math.floor(n/60)).padStart(2,'0')}:${String(n%60).padStart(2,'0')}`;

  const [sessoes, setSessoes] = useState([]);
  const carregarSessoes = React.useCallback(async ()=>{
    // sessões do cliente deste projeto, dos últimos 30 dias em diante
    const { data: proj } = await supabase.from('projects').select('client').eq('id', projectId).maybeSingle();
    if(!proj?.client) return;
    const hoje = new Date().toISOString().slice(0,10);
    const { data } = await supabase.from('sessions')
      .select('id,date,activity,professional,time_start,time_end,local_id,client')
      .eq('client', proj.client).gte('date', hoje).neq('state','cancelled')
      .order('date',{ascending:true}).limit(300);   // só sessões de hoje em diante
    setSessoes(data||[]);
  },[projectId]);
  useEffect(()=>{ if(aberto) carregarSessoes(); },[aberto, carregarSessoes]);

  const criar = async () => {
    const f = nova;
    if(!f.data || !f.servico || !f.hora_inicio || !f.hora_fim){ setMsg('Preenche data, serviço e horário.'); return; }
    const ini=hm(f.hora_inicio), fim=hm(f.hora_fim), dur=parseInt(f.duracao_slot||15,10);
    const pIni=f.pausa_inicio?hm(f.pausa_inicio):null, pFim=f.pausa_fim?hm(f.pausa_fim):null;
    if(ini==null||fim==null||fim<=ini||!dur){ setMsg('Horário inválido.'); return; }
    const { data: ag, error } = await supabase.from('agendas').insert({
      project_id:projectId, data:f.data, servico:f.servico, local:f.local||null, profissional:f.profissional||null,
      hora_inicio:f.hora_inicio, hora_fim:f.hora_fim, duracao_slot:dur,
      pausa_inicio:f.pausa_inicio||null, pausa_fim:f.pausa_fim||null, criado_por:autor||null,
      session_id:f.session_id||null,
    }).select('*').single();
    if(error){ setMsg('Erro: '+error.message); return; }
    // gera em blocos: a pausa é respeitada tal como definida (a tarde recomeça à hora exata)
    const blocos = (pIni!=null && pFim!=null && pIni>ini && pFim<fim)
      ? [[ini, pIni], [pFim, fim]]
      : [[ini, fim]];
    const linhas=[];
    blocos.forEach(([bIni, bFim])=>{
      for(let t=bIni; t+dur<=bFim; t+=dur){
        linhas.push({ agenda_id:ag.id, hora_inicio:mh(t), hora_fim:mh(t+dur), estado:'Livre', nota:null, modalidade:f.modalidade||'Presencial' });
      }
    });
    if(linhas.length) await supabase.from('agenda_slots').insert(linhas);
    setNova(null); setMsg(''); carregar(); abrirSlots(ag.id);
  };

  const abrirSlots = async (agendaId) => {
    if(slotsDe===agendaId){ setSlotsDe(null); setSlots([]); return; }
    const { data } = await supabase.from('agenda_slots').select('*').eq('agenda_id', agendaId).order('hora_inicio');
    setSlots(data||[]); setSlotsDe(agendaId);
  };
  const patchSlot = async (s, patch) => {
    const { data } = await supabase.from('agenda_slots').update({ ...patch, atualizado_por:autor||null, atualizado_em:new Date().toISOString() }).eq('id', s.id).select('*').single();
    if(data) setSlots(prev=>prev.map(x=>x.id===data.id?data:x));
  };
  const apagarAgenda = async (ag) => {
    if(!window.confirm(`Apagar a agenda de ${ag.data} (${ag.servico})?\n\nApaga também as marcações desse dia.`)) return;
    await supabase.from('agendas').delete().eq('id', ag.id);
    if(slotsDe===ag.id){ setSlotsDe(null); setSlots([]); }
    carregar();
  };
  const linkProfissional = async (ag) => {
    let { data: tok } = await supabase.from('agenda_tokens').select('*').eq('agenda_id', ag.id).maybeSingle();
    if(!tok){
      const t=(crypto.randomUUID?crypto.randomUUID():String(Math.random())).replace(/-/g,'').slice(0,16);
      const { data } = await supabase.from('agenda_tokens').insert({ token:t, agenda_id:ag.id, profissional:ag.profissional||null }).select('*').single();
      tok=data;
    }
    const link=`${window.location.origin}/a/${tok.token}`;
    navigator.clipboard?.writeText(link);
    setMsg(`Link do profissional copiado: ${link}`); setTimeout(()=>setMsg(''), 6000);
  };

  const COR = { 'Livre':'#F4F1FB', 'Bloqueado':'#EFEFEF', 'Agendado':'#EDE7F6', 'Compareceu':'#EAFAF1', 'Chegou atrasado':'#FEF5E7', 'Não compareceu':'#FDECEA' };
  const TXT = { 'Livre':'#8888AA', 'Bloqueado':'#999', 'Agendado':'#691FB1', 'Compareceu':'#27AE60', 'Chegou atrasado':'#E67E22', 'Não compareceu':'#C0392B' };
  const resumo = (ss)=>{
    const c=(e)=>ss.filter(x=>x.estado===e).length;
    return `${c('Agendado')+c('Compareceu')+c('Não compareceu')}/${ss.filter(x=>x.estado!=='Bloqueado').length} ocupados · ${c('Compareceu')} presenças · ${c('Não compareceu')} faltas`;
  };

  return (
    <div style={{ marginTop:12, paddingTop:10, borderTop:`1px dashed ${C.border}` }}>
      <button onClick={()=>setAberto(a=>!a)} style={{ background:'none', border:'none', color:C.purple, fontSize:11, fontWeight:700, cursor:'pointer', padding:0, fontFamily:"'DM Sans',sans-serif", textTransform:'uppercase', letterSpacing:0.6 }}>
        🗓️ Mapas de agendamento{agendas.length>0?` (${agendas.length})`:''} {aberto?'▲':'▼'}
      </button>
      {aberto&&(
        <div style={{ marginTop:10 }}>
          {agendas.length===0&&!nova&&<div style={{ fontSize:12, color:C.textLight, marginBottom:8 }}>Sem dias agendados. Cria um dia de serviço e o sistema gera as marcações.</div>}

          {agendas.map(ag=>(
            <div key={ag.id} style={{ border:`1px solid ${C.border}`, borderRadius:8, marginBottom:8, background:'#FBFAFF' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 12px', flexWrap:'wrap' }}>
                <span style={{ fontWeight:700, color:C.purple, cursor:'pointer' }} onClick={()=>abrirSlots(ag.id)}>{ag.data} · {ag.servico}</span>
                <span style={{ fontSize:11, color:C.textLight }}>{ag.hora_inicio?.slice(0,5)}–{ag.hora_fim?.slice(0,5)} · {ag.duracao_slot}min{ag.local?` · ${ag.local}`:''}{ag.profissional?` · ${ag.profissional}`:''}</span>
                <span style={{ flex:1 }}/>
                {podeEditar&&<label style={{ fontSize:11, color:C.textMid, display:'flex', alignItems:'center', gap:4, cursor:'pointer' }}>
                  <input type="checkbox" checked={!!ag.visivel_cliente}
                    onChange={async e=>{ const v=e.target.checked; await supabase.from('agendas').update({ visivel_cliente:v }).eq('id', ag.id); carregar(); }}/>
                  visível ao cliente
                </label>}
                {podeEditar&&ag.visivel_cliente&&<label style={{ fontSize:11, color:C.textMid, display:'flex', alignItems:'center', gap:4, cursor:'pointer' }}>
                  <input type="checkbox" checked={!!ag.ocultar_nomes}
                    onChange={async e=>{ const v=e.target.checked; await supabase.from('agendas').update({ ocultar_nomes:v }).eq('id', ag.id); carregar(); }}/>
                  ocultar nomes
                </label>}
                {podeEditar&&<button onClick={()=>linkProfissional(ag)} style={{ border:'none', background:'transparent', color:'#1A6FA0', fontSize:11, fontWeight:700, cursor:'pointer' }}>link do profissional</button>}
                <button onClick={()=>abrirSlots(ag.id)} style={{ border:'none', background:'transparent', color:C.textLight, fontSize:12, cursor:'pointer' }}>{slotsDe===ag.id?'▲':'▼'}</button>
                {podeEditar&&<button onClick={()=>apagarAgenda(ag)} style={{ border:'none', background:'transparent', color:'#C0392B', fontSize:12, cursor:'pointer' }}>🗑</button>}
              </div>
              {slotsDe===ag.id&&(
                <div style={{ padding:'0 12px 12px' }}>
                  <div style={{ fontSize:11, color:C.textLight, marginBottom:8 }}>{resumo(slots)}</div>
                  {slots.map(s=>(
                    <div key={s.id} style={{ display:'flex', alignItems:'center', gap:8, padding:'4px 6px', marginBottom:3, borderRadius:6, background:COR[s.estado]||'#fff', flexWrap:'wrap' }}>
                      <span style={{ fontSize:12, fontWeight:700, minWidth:88 }}>{s.hora_inicio?.slice(0,5)}–{s.hora_fim?.slice(0,5)}</span>
                      {podeEditar ? (
                        <input value={s.participante||''} onChange={e=>setSlots(prev=>prev.map(x=>x.id===s.id?{...x, participante:e.target.value}:x))}
                          onBlur={e=>patchSlot(s, { participante:e.target.value||null, estado: e.target.value? (s.estado==='Livre'?'Agendado':s.estado) : (s.estado==='Agendado'?'Livre':s.estado) })}
                          placeholder={s.estado==='Bloqueado'?'—':'nome do participante'} disabled={s.estado==='Bloqueado'}
                          style={{ flex:1, minWidth:150, padding:'5px 8px', border:`1px solid ${C.border}`, borderRadius:5, fontSize:12, fontFamily:"'DM Sans',sans-serif", background:s.estado==='Bloqueado'?'#F7F7F7':'#fff' }}/>
                      ) : <span style={{ flex:1, fontSize:12 }}>{s.participante||'—'}</span>}
                      {podeEditar&&(
                        <input value={s.link_sessao||''} onChange={e=>setSlots(prev=>prev.map(x=>x.id===s.id?{...x, link_sessao:e.target.value}:x))}
                          onBlur={e=>patchSlot(s,{ link_sessao:e.target.value.trim()||null })}
                          placeholder="link da sessão (Teams…)" disabled={s.estado==='Bloqueado'}
                          style={{ flex:1, minWidth:150, padding:'5px 8px', border:`1px solid ${C.border}`, borderRadius:5, fontSize:11, fontFamily:"'DM Sans',sans-serif", background:s.estado==='Bloqueado'?'#F7F7F7':'#fff' }}/>
                      )}
                      {podeEditar&&(
                        <select value={s.estado} onChange={e=>patchSlot(s,{ estado:e.target.value })}
                          style={{ padding:'4px 6px', border:`1px solid ${C.border}`, borderRadius:5, fontSize:11, color:TXT[s.estado], fontWeight:700, fontFamily:"'DM Sans',sans-serif" }}>
                          {['Livre','Bloqueado','Agendado','Compareceu','Chegou atrasado','Não compareceu'].map(e=><option key={e}>{e}</option>)}
                        </select>
                      )}
                      {podeEditar&&(
                        <select value={s.modalidade||'Presencial'} onChange={e=>patchSlot(s,{ modalidade:e.target.value })}
                          style={{ padding:'4px 6px', border:`1px solid ${C.border}`, borderRadius:5, fontSize:11, fontWeight:700, fontFamily:"'DM Sans',sans-serif", color:(s.modalidade==='Online')?'#1A6FA0':C.textMid }}>
                          {['Presencial','Online'].map(e=><option key={e}>{e}</option>)}
                        </select>
                      )}
                      {s.nota&&<span style={{ fontSize:11, color:C.textLight }}>💬 {s.nota}</span>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {podeEditar&&!nova&&(
            <div style={{ marginTop:8, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
              <select defaultValue="" onChange={e=>{
                  const s = sessoes.find(x=>x.id===e.target.value); if(!s) return;
                  setNova({ data:s.date, servico:s.activity||'', local:'', profissional:s.professional||'',
                            hora_inicio:String(s.time_start||'09:00').slice(0,5), hora_fim:String(s.time_end||'18:00').slice(0,5),
                            duracao_slot:15, pausa_inicio:'13:00', pausa_fim:'14:00', session_id:s.id });
                  e.target.value='';
                }}
                style={{ padding:'7px 10px', border:`1px solid ${C.purple}`, borderRadius:6, fontSize:11, fontWeight:700, color:C.purple, background:C.purpleLight, fontFamily:"'DM Sans',sans-serif", cursor:'pointer', maxWidth:340 }}>
                <option value="">+ Criar mapa a partir de uma sessão do calendário…</option>
                {sessoes.map(s=>(
                  <option key={s.id} value={s.id}>
                    {s.date} · {s.activity||'(sem atividade)'} · {s.professional||'(sem profissional)'}{s.time_start?` · ${String(s.time_start).slice(0,5)}-${String(s.time_end||'').slice(0,5)}`:''}
                  </option>
                ))}
              </select>
              <button onClick={()=>setNova({ data:new Date().toISOString().slice(0,10), servico:'', local:'', profissional:'', hora_inicio:'09:00', hora_fim:'18:00', duracao_slot:15, pausa_inicio:'13:00', pausa_fim:'14:00' })}
                style={{ background:'none', border:'none', color:C.textLight, fontSize:11, cursor:'pointer', textDecoration:'underline', fontFamily:"'DM Sans',sans-serif" }}>
                ou criar de raiz
              </button>
              {sessoes.length===0&&<span style={{ fontSize:11, color:C.textLight }}>Sem sessões futuras deste cliente no calendário.</span>}
            </div>
          )}
          {nova&&(
            <div style={{ marginTop:10, background:'#FBFAFF', border:`1px solid ${C.border}`, borderRadius:8, padding:12, display:'flex', flexWrap:'wrap', gap:8, alignItems:'flex-end' }}>
              {nova.session_id&&<div style={{ width:'100%', fontSize:11, color:'#1A6FA0', background:'#F4F9FF', border:'1px solid #CFE6F7', borderRadius:6, padding:'6px 10px' }}>
                Dados preenchidos a partir da sessão do calendário. Indica a duração do slot e a pausa.
              </div>}
              {[['data','Data','date',110],['servico','Serviço','text',150],['local','Local','text',130],['profissional','Profissional','text',150],
                ['hora_inicio','Início','time',95],['hora_fim','Fim','time',95],['duracao_slot','Slot (min)','number',80],
                ['pausa_inicio','Pausa início','time',95],['pausa_fim','Pausa fim','time',95]].map(([k,l,t,w])=>(
                <div key={k}>
                  <label style={{ fontSize:10, color:C.textLight, display:'block' }}>{l}</label>
                  <input type={t} value={nova[k]||''} onChange={e=>setNova({...nova,[k]:e.target.value})}
                    style={{ width:w, padding:'7px 8px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif" }}/>
                </div>
              ))}
              <div>
                <label style={{ fontSize:10, color:C.textLight, display:'block' }}>Modalidade</label>
                <select value={nova.modalidade||'Presencial'} onChange={e=>setNova({...nova, modalidade:e.target.value})}
                  style={{ padding:'7px 8px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif" }}>
                  {['Presencial','Online'].map(m=><option key={m}>{m}</option>)}
                </select>
              </div>
              <button onClick={criar} style={{ background:C.purple, border:'none', borderRadius:6, color:'#fff', padding:'8px 14px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Criar dia</button>
              <button onClick={()=>{setNova(null);setMsg('');}} style={{ background:'#fff', border:`1px solid ${C.border}`, borderRadius:6, color:C.textLight, padding:'8px 12px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
            </div>
          )}
      {msg&&<div style={{ marginTop:8, fontSize:11, color:msg.startsWith('Erro')?'#C0392B':'#1A6FA0' }}>{msg}</div>}
        </div>
      )}
    </div>
  );
}

function ProjectPartilhas({ projectId, autor, nDocsVisiveis }) {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState('');
  const [verApagadas, setVerApagadas] = useState(false);
  const carregar = React.useCallback(async ()=>{
    const { data } = await supabase.from('project_shares').select('*').eq('project_id', projectId).order('created_at',{ascending:false});
    setLista(data||[]);
  },[projectId]);
  useEffect(()=>{ carregar(); },[carregar]);

  const criar = async () => {
    const em=(form.email_cliente||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){ setMsg('Indica um email válido.'); return; }
    const token = (crypto.randomUUID?crypto.randomUUID():String(Math.random())).replace(/-/g,'').slice(0,16);
    const { error } = await supabase.from('project_shares').insert({
      project_id:projectId, token, email_cliente:em, nome_cliente:(form.nome_cliente||'').trim()||null,
      permissao:form.permissao||'ver', validade:form.validade||null, partilhado_por:autor||null,
    });
    if(error){ setMsg('Erro: '+error.message); return; }
    if(form.notificar!==false){
      const r = await enviarEmail({ token, email:em, nome:(form.nome_cliente||'').trim() });
      setMsg(r ? 'Link criado e email enviado ao cliente.' : 'Link criado — mas o email falhou; copia o link e envia à mão.');
      setTimeout(()=>setMsg(''), 6000);
    }
    setForm(null); carregar();
  };
  const enviarEmail = async ({ token, email, nome }) => {
    const link = `${window.location.origin}/c/${token}`;
    const html = `<div style="font-family:Helvetica,Arial,sans-serif;max-width:560px;margin:0 auto;padding:24px;color:#1A1A2E">
      <div style="background:#691FB1;border-radius:12px 12px 0 0;padding:18px 24px"><span style="color:#fff;font-size:17px;font-weight:700">Portal Workwell</span></div>
      <div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:24px">
        <p style="font-size:15px;margin:0 0 10px">Ol&aacute;${nome?` ${nome}`:''},</p>
        <p style="font-size:14px;line-height:1.6;color:#555;margin:0 0 16px">J&aacute; pode aceder aos documentos do vosso projeto no Portal Workwell, onde encontrar&aacute; tamb&eacute;m a fatura&ccedil;&atilde;o e outra informa&ccedil;&atilde;o &uacute;til.</p>
        <div style="text-align:center;margin:20px 0"><a href="${link}" style="display:inline-block;background:#691FB1;color:#fff;text-decoration:none;border-radius:8px;padding:12px 26px;font-size:14px;font-weight:700">Aceder ao Portal</a></div>
        <div style="background:#F7F5FC;border-radius:8px;padding:14px 16px;font-size:13px;color:#555;line-height:1.6">
          <strong style="color:#691FB1">Como entrar</strong><br/>
          N&atilde;o precisa de criar conta nem de palavra-passe. Ao abrir o link, indique este endere&ccedil;o de email e receber&aacute; um c&oacute;digo de 6 d&iacute;gitos para entrar. O acesso fica ativo neste dispositivo durante 7 dias.
        </div>
        <p style="font-size:11px;color:#8888AA;margin:16px 0 0">Este acesso &eacute; pessoal. Qualquer quest&atilde;o: apoio@workwell.pt</p>
      </div></div>`;
    try {
      const { error } = await supabase.functions.invoke('Send-email', {
        body: { to: email, toName: nome || email, subject: 'Portal Workwell — acesso aos documentos do vosso projeto', html, fromName: 'Workwell' }
      });
      return !error;
    } catch { return false; }
  };
  const reenviar = async (s) => {
    const ok = await enviarEmail({ token:s.token, email:s.email_cliente, nome:s.nome_cliente });
    setMsg(ok ? `Email reenviado a ${s.email_cliente}.` : 'Não foi possível enviar o email.');
    setTimeout(()=>setMsg(''), 5000);
  };
  const apagar = async (s) => {
    if(!window.confirm(`Apagar a partilha de ${s.email_cliente}?\n\nO link deixa de funcionar e a partilha sai da lista. Fica o registo de quem a apagou.`)) return;
    await supabase.from('project_shares').update({ ativo:false, apagado_em:new Date().toISOString(), apagado_por:autor||null }).eq('id', s.id);
    carregar();
  };
  const revogar = async (s) => {
    if(!window.confirm(`Revogar o acesso de ${s.email_cliente}?\n\nO link deixa de funcionar imediatamente.`)) return;
    await supabase.from('project_shares').update({ ativo:false }).eq('id', s.id); carregar();
  };
  const reativar = async (s) => { await supabase.from('project_shares').update({ ativo:true }).eq('id', s.id); carregar(); };
  const copiar = (s) => {
    const link = `${window.location.origin}/c/${s.token}`;
    navigator.clipboard?.writeText(link);
    setMsg(`Link copiado: ${link}`); setTimeout(()=>setMsg(''), 4000);
  };

  return (
    <div style={{ marginTop:12, background:'#F4F9FF', border:'1px solid #CFE6F7', borderRadius:8, padding:12 }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:8 }}>
        <span style={{ fontSize:11, fontWeight:700, color:'#1A6FA0', textTransform:'uppercase', letterSpacing:0.6 }}>🔗 Partilhar com o cliente</span>
        <span style={{ fontSize:11, color:C.textLight }}>{nDocsVisiveis} documento(s) marcados como visíveis</span>
        <span style={{ flex:1 }}/>
        {!form&&<button onClick={()=>setForm({ email_cliente:'', nome_cliente:'', permissao:'ver', validade:'' })}
          style={{ background:'#1A6FA0', border:'none', borderRadius:6, color:'#fff', padding:'5px 11px', fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>+ Nova partilha</button>}
      </div>

      {lista.length===0&&!form&&<div style={{ fontSize:11, color:C.textLight }}>Ainda não partilhado. O cliente só vê os documentos marcados como visíveis.</div>}

      {lista.filter(s=>verApagadas ? true : !s.apagado_em).map(s=>(
        <div key={s.id} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12, padding:'5px 0', borderBottom:'1px solid #E3EFF9', flexWrap:'wrap', opacity:s.ativo?1:0.5 }}>
          <span style={{ fontWeight:700 }}>{s.nome_cliente||s.email_cliente}</span>
          {s.nome_cliente&&<span style={{ color:C.textLight }}>{s.email_cliente}</span>}
          <span style={{ background:s.permissao==='editar'?'#FEF5E7':'#EDE7F6', color:s.permissao==='editar'?'#E67E22':C.purple, borderRadius:10, padding:'1px 8px', fontSize:10, fontWeight:700 }}>
            {s.permissao==='editar'?'pode editar':'só ver'}
          </span>
          {s.validade&&<span style={{ color:C.textLight, fontSize:10 }}>até {s.validade}</span>}
          <span style={{ color:C.textLight, fontSize:10 }}>
            {s.n_acessos>0?`${s.n_acessos} acesso(s)${s.ultimo_acesso?` · último ${String(s.ultimo_acesso).slice(0,10)}`:''}`:'ainda não abriu'}
          </span>
          <span style={{ flex:1 }}/>
          {s.ativo?<>
            <button onClick={()=>copiar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#1A6FA0', fontSize:11, fontWeight:700 }}>copiar link</button>
            <button onClick={()=>reenviar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#1A6FA0', fontSize:11 }}>reenviar email</button>
            <button onClick={()=>revogar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#C0392B', fontSize:11 }}>revogar</button>
            <button onClick={()=>apagar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#C0392B', fontSize:12 }} title="Apagar partilha">🗑</button>
          </>:(s.apagado_em
              ? <span style={{ fontSize:10, color:C.textLight }}>apagada por {s.apagado_por||'—'} · {String(s.apagado_em).slice(0,10)}</span>
              : <>
                  <button onClick={()=>reativar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#1A6FA0', fontSize:11 }}>reativar</button>
                  <button onClick={()=>apagar(s)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#C0392B', fontSize:12 }} title="Apagar partilha">🗑</button>
                </>)}
        </div>
      ))}

      {form&&(
        <div style={{ marginTop:10, display:'flex', gap:8, flexWrap:'wrap', alignItems:'flex-end' }}>
          <div><label style={{ fontSize:10, color:C.textLight, display:'block' }}>Email do cliente *</label>
            <input value={form.email_cliente} onChange={e=>setForm({...form, email_cliente:e.target.value})} placeholder="nome@cliente.pt"
              style={{ padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, width:190, fontFamily:"'DM Sans',sans-serif" }}/></div>
          <div><label style={{ fontSize:10, color:C.textLight, display:'block' }}>Nome (opcional)</label>
            <input value={form.nome_cliente} onChange={e=>setForm({...form, nome_cliente:e.target.value})}
              style={{ padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, width:150, fontFamily:"'DM Sans',sans-serif" }}/></div>
          <div><label style={{ fontSize:10, color:C.textLight, display:'block' }}>Permissão</label>
            <select value={form.permissao} onChange={e=>setForm({...form, permissao:e.target.value})}
              style={{ padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif" }}>
              <option value="ver">só ver</option><option value="editar">pode editar</option>
            </select></div>
          <div><label style={{ fontSize:10, color:C.textLight, display:'block' }}>Validade (opcional)</label>
            <input type="date" value={form.validade} onChange={e=>setForm({...form, validade:e.target.value})}
              style={{ padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif" }}/></div>
          <label style={{ fontSize:11, color:C.textMid, display:'flex', alignItems:'center', gap:5, cursor:'pointer' }}>
            <input type="checkbox" checked={form.notificar!==false} onChange={e=>setForm({...form, notificar:e.target.checked})}/>
            enviar email ao cliente
          </label>
          <button onClick={criar} style={{ background:'#1A6FA0', border:'none', borderRadius:6, color:'#fff', padding:'8px 14px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Criar link</button>
          <button onClick={()=>{setForm(null);setMsg('');}} style={{ background:'#fff', border:`1px solid ${C.border}`, borderRadius:6, color:C.textLight, padding:'8px 12px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
        </div>
      )}
      {lista.some(s=>s.apagado_em)&&(
        <button onClick={()=>setVerApagadas(v=>!v)} style={{ marginTop:6, background:'none', border:'none', color:C.textLight, fontSize:10, cursor:'pointer', textDecoration:'underline', fontFamily:"'DM Sans',sans-serif" }}>
          {verApagadas?'ocultar apagadas':`ver apagadas (${lista.filter(s=>s.apagado_em).length})`}
        </button>
      )}
      {msg&&<div style={{ marginTop:8, fontSize:11, color:msg.startsWith('Erro')?'#C0392B':'#1A6FA0' }}>{msg}</div>}
    </div>
  );
}

function ProjectDocs({ projectId, autor, podeEditar }) {
  const [docs, setDocs] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [carregado, setCarregado] = useState(false);
  const [form, setForm] = useState(null);   // {id?, titulo, url, tipo, visivel_cliente}
  const [msg, setMsg] = useState('');
  const TIPOS = ['Relatório','Contrato','Proposta','Fatura','Mapa / Agendamento','Apresentação','Outro'];

  const carregar = React.useCallback(async () => {
    const { data } = await supabase.from('project_docs').select('*').eq('project_id', projectId).order('created_at', { ascending:false });
    setDocs(data||[]); setCarregado(true);
  }, [projectId]);
  useEffect(()=>{ if(aberto&&!carregado) carregar(); }, [aberto, carregado, carregar]);
  useEffect(()=>{ carregar(); }, [carregar]);

  const guardar = async () => {
    const t=(form.titulo||'').trim(), u=(form.url||'').trim();
    if(!t||!u){ setMsg('Título e link são obrigatórios.'); return; }
    if(!/^https?:\/\//i.test(u)){ setMsg('O link tem de começar por https://'); return; }
    const row = { project_id:projectId, titulo:t, url:u, tipo:form.tipo||'Outro', visivel_cliente:!!form.visivel_cliente };
    const { error } = form.id
      ? await supabase.from('project_docs').update(row).eq('id', form.id)
      : await supabase.from('project_docs').insert({ ...row, autor: autor||null });
    if(error){ setMsg('Erro: '+error.message); return; }
    setForm(null); setMsg(''); carregar();
  };
  const apagar = async (d) => {
    if(!window.confirm(`Remover "${d.titulo}"?\n\nO ficheiro original não é apagado — só a ligação.`)) return;
    await supabase.from('project_docs').delete().eq('id', d.id); carregar();
  };
  const icone = (t) => t==='Relatório'?'📊':t==='Contrato'?'📄':t==='Proposta'?'📝':t==='Fatura'?'🧾':t==='Mapa / Agendamento'?'🗓️':t==='Apresentação'?'📽️':'🔗';

  return (
    <div style={{ marginTop:14, borderTop:`1px solid ${C.border}`, paddingTop:12 }}>
      <button onClick={()=>setAberto(a=>!a)} style={{ background:'none', border:'none', color:C.purple, fontSize:12, fontWeight:700, cursor:'pointer', padding:0, fontFamily:"'DM Sans',sans-serif" }}>
        📎 Documentos e agendamentos{docs.length>0?` (${docs.length})`:''} {aberto?'▲':'▼'}
      </button>
      {aberto&&(
        <div style={{ marginTop:10 }}>
          {docs.length===0&&<div style={{ fontSize:12, color:C.textLight, marginBottom:8 }}>Sem documentos. Adiciona o link do SharePoint, do relatório, do contrato…</div>}
          {docs.map(d=>(
            <div key={d.id} style={{ display:'flex', alignItems:'center', gap:8, padding:'6px 8px', borderBottom:'1px solid #F4F1FB', fontSize:12, flexWrap:'wrap' }}>
              <span>{icone(d.tipo)}</span>
              <a href={d.url} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                 style={{ color:C.purple, fontWeight:700, textDecoration:'none' }}>{d.titulo}</a>
              <span style={{ color:C.textLight }}>{d.tipo}</span>
              {d.visivel_cliente&&<span style={{ background:'#E5F7FF', color:'#1A6FA0', borderRadius:10, padding:'1px 8px', fontSize:10, fontWeight:700 }}>visível ao cliente</span>}
              <span style={{ flex:1 }}/>
              <span style={{ color:C.textLight, fontSize:10 }}>{d.autor||''}{d.created_at?` · ${String(d.created_at).slice(0,10)}`:''}</span>
              {podeEditar&&<>
                <button onClick={()=>setForm({ id:d.id, titulo:d.titulo, url:d.url, tipo:d.tipo, visivel_cliente:d.visivel_cliente })}
                  style={{ border:'none', background:'transparent', cursor:'pointer', color:C.textLight, fontSize:12 }}>✏️</button>
                <button onClick={()=>apagar(d)} style={{ border:'none', background:'transparent', cursor:'pointer', color:'#C0392B', fontSize:12 }}>🗑</button>
              </>}
            </div>
          ))}
          <ProjectAgendas projectId={projectId} autor={autor} podeEditar={podeEditar}/>
          {podeEditar&&<ProjectPartilhas projectId={projectId} autor={autor} nDocsVisiveis={docs.filter(d=>d.visivel_cliente).length}/>}
          {podeEditar&&!form&&(
            <button onClick={()=>setForm({ titulo:'', url:'', tipo:'Relatório', visivel_cliente:false })}
              style={{ marginTop:10, background:C.purpleLight, border:'none', borderRadius:6, color:C.purple, padding:'6px 12px', fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
              + Adicionar documento / link
            </button>
          )}
          {form&&(
            <div style={{ marginTop:10, background:'#FBFAFF', border:`1px solid ${C.border}`, borderRadius:8, padding:12, display:'flex', flexWrap:'wrap', gap:8, alignItems:'flex-end' }}>
              <div style={{ flex:'1 1 180px' }}>
                <label style={{ fontSize:10, color:C.textLight, display:'block' }}>Título *</label>
                <input value={form.titulo} onChange={e=>setForm({...form, titulo:e.target.value})} placeholder="Relatório trimestral"
                  style={{ width:'100%', padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }}/>
              </div>
              <div style={{ flex:'2 1 260px' }}>
                <label style={{ fontSize:10, color:C.textLight, display:'block' }}>Link (SharePoint, Word, PDF…) *</label>
                <input value={form.url} onChange={e=>setForm({...form, url:e.target.value})} placeholder="https://workwellpt594.sharepoint.com/..."
                  style={{ width:'100%', padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }}/>
              </div>
              <div>
                <label style={{ fontSize:10, color:C.textLight, display:'block' }}>Tipo</label>
                <select value={form.tipo} onChange={e=>setForm({...form, tipo:e.target.value})}
                  style={{ padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif" }}>
                  {TIPOS.map(t=><option key={t}>{t}</option>)}
                </select>
              </div>
              <label style={{ fontSize:11, color:C.textMid, display:'flex', alignItems:'center', gap:5, cursor:'pointer' }}>
                <input type="checkbox" checked={!!form.visivel_cliente} onChange={e=>setForm({...form, visivel_cliente:e.target.checked})}/>
                visível ao cliente
              </label>
              <button onClick={guardar} style={{ background:C.purple, border:'none', borderRadius:6, color:'#fff', padding:'8px 14px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{form.id?'Guardar':'Adicionar'}</button>
              <button onClick={()=>{setForm(null);setMsg('');}} style={{ background:'#fff', border:`1px solid ${C.border}`, borderRadius:6, color:C.textLight, padding:'8px 12px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
              {msg&&<div style={{ width:'100%', color:'#C0392B', fontSize:11 }}>{msg}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Histórico de alterações do projeto (gravado pela base em projeto_historico)
const CAMPOS_HIST = {
  criado:'Projeto criado', name:'Nome', client:'Cliente', status:'Estado', active:'Ativo', value:'Valor',
  billing_model:'Modelo de faturação', billing_month:'Mês de faturação', contract_start:'Início do contrato',
  contract_end:'Fim do contrato', meses_pausa:'Meses sem faturação', parent_id:'Programa-mãe', is_mae:'Programa-mãe (é mãe)',
  entidade_faturacao_id:'Entidade que fatura', po_id:'PO', fat_contacto_nome:'Contacto de faturação',
  fat_contacto_email:'Email de faturação', business_area:'Área', business_areas:'Áreas', servico_codigo:'Código do serviço',
  tipo_negocio:'Tipo de negócio', commercial_name:'Comercial', owner_name:'Responsável Operações', description:'Descrição',
};
function ProjetoHistorico({ projectId }) {
  const [aberto, setAberto] = useState(false);
  const [linhas, setLinhas] = useState(null);
  useEffect(() => {
    if (!aberto || linhas) return;
    supabase.from('projeto_historico').select('*').eq('projeto_id', projectId)
      .order('alterado_em', { ascending: false }).limit(300)
      .then(({ data }) => setLinhas(data || []));
  }, [aberto, linhas, projectId]);
  useEffect(() => { setLinhas(null); }, [projectId]);
  const fmt = (campo, v) => {
    if (v == null || v === '') return '—';
    if (campo === 'active' || campo === 'is_mae') return v === 'true' ? 'sim' : 'não';
    if (campo === 'value') return Number(v).toLocaleString('pt-PT', { minimumFractionDigits: 2 }) + ' €';
    if (campo === 'parent_id' || campo.endsWith('_id')) return 'alterado';
    if (/^\d{4}-\d{2}-\d{2}/.test(v)) return v.slice(8,10) + '/' + v.slice(5,7) + '/' + v.slice(0,4);
    const t = String(v).replace(/^\[|\]$/g, '').replace(/"/g, '');
    return t.length > 80 ? t.slice(0, 80) + '…' : t;
  };
  return (
    <div style={{ marginTop:14, border:'1px solid #E4DEFA', borderRadius:9, background:'#fff' }}>
      <div onClick={()=>setAberto(a=>!a)} style={{ padding:'10px 14px', cursor:'pointer', display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:700, color:'#4A4A6A' }}>
        <span>🕓 Histórico de alterações</span><span style={{ color:'#8888AA' }}>{aberto?'▲':'▼'}</span>
      </div>
      {aberto && (
        <div style={{ padding:'0 14px 12px', maxHeight:320, overflowY:'auto' }}>
          {!linhas ? <div style={{ fontSize:12, color:'#8888AA' }}>A carregar…</div>
          : linhas.length === 0 ? <div style={{ fontSize:12, color:'#8888AA' }}>Sem alterações registadas desde que o histórico foi ligado.</div>
          : linhas.map(h => (
            <div key={h.id} style={{ display:'flex', gap:10, fontSize:12, padding:'6px 0', borderTop:'1px solid #F0ECFA', flexWrap:'wrap' }}>
              <span style={{ color:'#8888AA', minWidth:108, fontVariantNumeric:'tabular-nums' }}>
                {new Date(h.alterado_em).toLocaleDateString('pt-PT')} {new Date(h.alterado_em).toLocaleTimeString('pt-PT',{hour:'2-digit',minute:'2-digit'})}</span>
              <span style={{ fontWeight:700, color:'#1A1A2E', minWidth:130 }}>{CAMPOS_HIST[h.campo] || h.campo}</span>
              <span style={{ flex:1, minWidth:160, color:'#4A4A6A' }}>
                {h.campo === 'criado' ? fmt('name', h.valor_depois)
                  : <>{fmt(h.campo, h.valor_antes)} <span style={{ color:'#691FB1' }}>→</span> <strong>{fmt(h.campo, h.valor_depois)}</strong></>}
              </span>
              <span style={{ color:'#8888AA' }}>{h.alterado_por}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ProjectNotas({ projectId, tipo, titulo, autor, autorEmail, nomeProjeto, projeto, cliente, clienteId, notificarFinanceiro }) {
  const [notas, setNotas] = useState([]);
  const [texto, setTexto] = useState('');
  const [saving, setSaving] = useState(false);
  // As notas de faturação vivem na MESMA tabela que o Financeiro lê (notas_faturacao),
  // para o que se escreve aqui aparecer também no Por Cliente. As outras notas
  // continuam em project_notes.
  const naFaturacao = tipo === 'faturacao';
  const load = async () => {
    if (naFaturacao) {
      if (!clienteId) { setNotas([]); return; }
      const { data } = await supabase.from('notas_faturacao').select('*')
        .eq('cliente_id', clienteId).order('created_at', { ascending: false });
      setNotas(data || []);
      return;
    }
    const { data } = await supabase.from('project_notes').select('*').eq('project_id', projectId).eq('tipo', tipo).order('created_at', { ascending: false });
    setNotas(data || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId, tipo, clienteId]);
  const adicionar = async () => {
    if (!texto.trim()) return;
    setSaving(true);
    const conteudo = texto.trim();
    const { error } = naFaturacao
      ? await supabase.from('notas_faturacao').insert({
          cliente_id: clienteId, project_id: projectId, projeto_nome: projeto || null,
          texto: conteudo, autor: autor || null })
      : await supabase.from('project_notes').insert({ project_id: projectId, tipo, texto: conteudo, autor: autor || null });
    setSaving(false);
    if (error) { alert('Erro ao gravar: ' + error.message); return; }
    // quem foi mencionado com @ recebe tarefa e email
    notificarMencoes({ texto: conteudo, autorNome: autor, autorEmail: autorEmail, projetoId: projectId, projetoNome: projeto || nomeProjeto,
      onde: tipo === 'faturacao' ? 'numa nota de faturação' : tipo === 'descricao' ? 'no briefing' : 'numa nota interna' });
    // Notas de faturação vão por email ao financeiro assim que são escritas —
    // é informação que não pode ficar perdida no briefing.
    if (notificarFinanceiro) {
      try {
        await supabase.functions.invoke('Send-email', {
          body: {
            to: 'financeiro@workwell.pt', toName: 'Financeiro',
            subject: `Nota de faturação — ${cliente || ''}${projeto ? ' · ' + projeto : ''}`.trim(),
            fromName: 'Workwell HUB',
            html: `<div style="font-family:Helvetica,Arial,sans-serif;max-width:520px;margin:0 auto;padding:24px;color:#1A1A2E">
<div style="background:#691FB1;border-radius:12px 12px 0 0;padding:16px 22px">
  <span style="color:#fff;font-size:16px;font-weight:700">&#128181; Nota de faturação</span></div>
<div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:22px">
  <p style="font-size:13px;color:#8888AA;margin:0 0 4px">${cliente || ''}</p>
  <p style="font-size:15px;font-weight:700;margin:0 0 14px">${projeto || ''}</p>
  <div style="background:#FAF8FF;border-left:3px solid #691FB1;border-radius:6px;padding:13px 16px;font-size:14px;line-height:1.6;white-space:pre-wrap">${conteudo.replace(/</g,'&lt;')}</div>
  <p style="font-size:12px;color:#8888AA;margin:16px 0 0">Registada por ${autor || 'alguém da equipa'} no HUB.</p>
  <div style="text-align:center;margin:18px 0 0">
    <a href="https://hub.workwell.pt/?page=kanban&projeto=${projectId}"
       style="display:inline-block;background:#691FB1;color:#fff;text-decoration:none;font-size:13px;font-weight:700;padding:10px 22px;border-radius:8px">Abrir o projeto</a>
  </div>
</div></div>`,
          },
        });
      } catch (_e) { /* a nota fica gravada mesmo que o email falhe */ }
    }
    setTexto(''); load();
  };
  const fmt = (d) => { try { return new Date(d).toLocaleDateString('pt-PT') + ' ' + new Date(d).toLocaleTimeString('pt-PT',{hour:'2-digit',minute:'2-digit'}); } catch { return d; } };
  return (
    <div style={{ marginBottom:14 }}>
      <div style={{ fontSize:12, fontWeight:700, color:'#691FB1', marginBottom:6, fontFamily:"'DM Sans',sans-serif" }}>{titulo}{notas.length>0?` (${notas.length})`:''}</div>
      {naFaturacao && !clienteId && (
        <div style={{ fontSize:11, color:'#C0392B', marginBottom:6 }}>
          Este projeto não tem cliente associado — liga-o primeiro para poderes escrever notas de faturação.
        </div>
      )}
      <div style={{ display:'flex', gap:6, marginBottom:8 }}>
        <CampoMencoes value={texto} onChange={setTexto} onEnter={adicionar}
          placeholder={notificarFinanceiro ? 'Condições, valores, prazos… o financeiro é avisado (@ para mencionar alguém)' : 'Escrever e Enter para adicionar… (@ para mencionar alguém)'}
          style={{ padding:'8px 10px', border:'1px solid #E4DEFA', borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}/>
        <button onClick={adicionar} disabled={saving} style={{ background:'#691FB1', border:'none', borderRadius:6, color:'#fff', padding:'8px 14px', fontSize:12, fontWeight:600, cursor:'pointer' }}>{saving?'...':'Adicionar'}</button>
      </div>
      {notas.length===0 ? <div style={{ fontSize:11, color:'#9A95B8', fontStyle:'italic' }}>Sem registos ainda.</div> :
       <div style={{ maxHeight:180, overflowY:'auto', border:'1px solid #F0ECFB', borderRadius:6, padding:'2px 10px' }}>
         {notas.map(n=>(
          <div key={n.id} style={{ padding:'7px 0', borderBottom:'1px solid #F0ECFB' }}>
            <div style={{ fontSize:12, color:'#2b2b2b', whiteSpace:'pre-wrap' }}>{n.texto}</div>
            <div style={{ fontSize:10, color:'#9A95B8', marginTop:3 }}>{n.autor?n.autor+' · ':''}{fmt(n.created_at)}</div>
          </div>
         ))}
       </div>}
    </div>
  );
}

function FaseNotas({ faseId, autor, autorEmail, projectId, projectName, faseNome }) {
  const [notas, setNotas] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [texto, setTexto] = useState('');
  const [saving, setSaving] = useState(false);
  const [carregado, setCarregado] = useState(false);

  const load = async () => {
    const { data } = await supabase.from('fase_notas').select('*').eq('fase_id', faseId).order('created_at', { ascending: false });
    setNotas(data || []); setCarregado(true);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [faseId]);

  const adicionar = async () => {
    if (!texto.trim()) return;
    setSaving(true);
    const { error } = await supabase.from('fase_notas').insert({ fase_id: faseId, texto: texto.trim(), autor: autor || null });
    setSaving(false);
    if (error) { alert('Erro ao gravar nota: ' + error.message); return; }
    notificarMencoes({ texto: texto.trim(), autorNome: autor, autorEmail, projetoId: projectId, projetoNome: projectName, onde: faseNome ? `numa nota da fase «${faseNome}»` : 'numa nota de uma fase' });
    setTexto(''); load();
  };

  const apagar = async (id) => {
    if (!window.confirm('Apagar esta nota?')) return;
    await supabase.from('fase_notas').delete().eq('id', id); load();
  };

  const fmt = (d) => { try { return new Date(d).toLocaleDateString('pt-PT') + ' ' + new Date(d).toLocaleTimeString('pt-PT',{hour:'2-digit',minute:'2-digit'}); } catch { return d; } };

  return (
    <div style={{ borderTop:`1px solid ${C.border}`, padding:'8px 14px 10px' }}>
      <button onClick={()=>setAberto(a=>!a)} style={{ background:'none', border:'none', color:C.purple, fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600, padding:0 }}>
        📝 Notas{carregado&&notas.length>0?` (${notas.length})`:''} {aberto?'▲':'▼'}
      </button>
      {aberto && (
        <div style={{ marginTop:8 }}>
          <div style={{ display:'flex', gap:6, marginBottom:8 }}>
            <CampoMencoes value={texto} onChange={setTexto} onEnter={adicionar} placeholder="Escrever nota… (@ para mencionar alguém)"
              style={{ padding:'7px 10px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}/>
            <button onClick={adicionar} disabled={saving} style={{ background:C.purple, border:'none', borderRadius:6, color:'#fff', padding:'7px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}>{saving?'...':'Adicionar'}</button>
          </div>
          {notas.length===0 ? <div style={{ fontSize:11, color:C.textLight, fontStyle:'italic' }}>Sem notas nesta fase.</div> :
           notas.map(n=>(
            <div key={n.id} style={{ display:'flex', gap:8, alignItems:'flex-start', padding:'6px 0', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, color:C.text }}>{n.texto}</div>
                <div style={{ fontSize:10, color:C.textLight, marginTop:2 }}>{n.autor?n.autor+' · ':''}{fmt(n.created_at)}</div>
              </div>
              <button onClick={()=>apagar(n.id)} style={{ background:'none', border:'none', color:'#C0392B', fontSize:11, cursor:'pointer' }}>🗑</button>
            </div>
           ))}
        </div>
      )}
    </div>
  );
}

function FaseTarefas({ faseId, projectId, projectName, users, autorEmail, autorNome, onMudou }) {
  const [tarefas, setTarefas] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [texto, setTexto] = useState('');
  const [data, setData] = useState('');
  const [resp, setResp] = useState(autorEmail || '');
  const [saving, setSaving] = useState(false);
  const [carregado, setCarregado] = useState(false);

  const load = async () => {
    const { data: d } = await supabase.from('project_tarefas').select('*').eq('fase_id', faseId).order('data_lembrete', { ascending: true, nullsFirst: false });
    setTarefas(d || []); setCarregado(true);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [faseId]);

  const emailAtribuicao = async (respEmail, respNome, txt, dataLembrete) => {
    try {
      const primeiroNome = (respNome || respEmail || '').split(' ')[0];
      const HUB_URL = 'https://hub.workwell.pt';
      const html = `<div style="font-family:Helvetica,Arial,sans-serif;max-width:480px;margin:0 auto;padding:24px;color:#1A1A2E"><div style="background:#691FB1;border-radius:12px 12px 0 0;padding:18px 24px"><span style="color:#fff;font-size:18px;font-weight:700">&#128203; Nova tarefa atribuida</span></div><div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:24px"><p style="font-size:15px;margin:0 0 16px">Ola ${primeiroNome},</p><p style="font-size:14px;line-height:1.6;color:#555;margin:0 0 16px"><b>${autorNome||autorEmail||'Alguem'}</b> atribuiu-te uma tarefa no projeto <b>${projectName||'-'}</b>:</p><div style="background:#F7F5FC;border:1px solid #E4DEFA;border-radius:8px;padding:14px;margin-bottom:16px"><div style="font-weight:700;color:#691FB1;font-size:15px;margin-bottom:4px">${(txt||'').replace(/</g,'&lt;')}</div>${dataLembrete?`<div style="font-size:13px;color:#555">&#128197; Lembrete: ${dataLembrete.split('-').reverse().join('/')}</div>`:''}</div><div style="text-align:center;margin:8px 0 4px"><a href="${HUB_URL}" style="display:inline-block;background:#691FB1;color:#fff;text-decoration:none;font-size:14px;font-weight:700;padding:12px 28px;border-radius:8px">Ver as minhas tarefas</a></div></div></div>`;
      await supabase.functions.invoke('Send-email', { body: {
        to: respEmail, toName: respNome || respEmail, subject: 'Nova tarefa atribuida: ' + (projectName || ''),
        html, fromName: 'Workwell - Projetos',
      }});
    } catch(e) { console.error('emailAtribuicao (nao bloqueia):', e); }
  };

  const adicionar = async () => {
    if (!texto.trim()) return;
    setSaving(true);
    const respEmail = resp || autorEmail || null;
    const respUser = (users||[]).find(u => u.email === respEmail);
    const respNome = respUser?.full_name || (respEmail===autorEmail ? autorNome : respEmail) || null;
    const { error } = await supabase.from('project_tarefas').insert({
      fase_id: faseId, project_id: projectId || null, texto: texto.trim(),
      data_lembrete: data || null, autor_email: autorEmail || null, autor_nome: autorNome || null,
      responsavel_email: respEmail, responsavel_nome: respNome,
    });
    setSaving(false);
    if (error) { alert('Erro ao gravar tarefa: ' + error.message); return; }
    if (respEmail) emailAtribuicao(respEmail, respNome, texto.trim(), data || null);
    setTexto(''); setData(''); setResp(autorEmail || ''); load();
    if (onMudou) onMudou();
  };

  const toggleFeita = async (t) => {
    const agoraFeita = !t.feita;
    await supabase.from('project_tarefas').update({ feita: agoraFeita, feita_em: agoraFeita ? new Date().toISOString() : null }).eq('id', t.id);
    load();
    if (onMudou) onMudou();
  };

  const apagar = async (id) => {
    if (!window.confirm('Apagar esta tarefa?')) return;
    await supabase.from('project_tarefas').delete().eq('id', id); load();
    if (onMudou) onMudou();
  };

  const hoje = new Date().toISOString().slice(0,10);
  const fmtD = (d) => { try { return new Date(d+'T00:00:00').toLocaleDateString('pt-PT'); } catch { return d; } };
  const porFazer = tarefas.filter(t=>!t.feita).length;

  return (
    <div style={{ borderTop:`1px solid ${C.border}`, padding:'8px 14px 10px' }}>
      <button onClick={()=>setAberto(a=>!a)} style={{ background:'none', border:'none', color:C.purple, fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:600, padding:0 }}>
        ⏲ Tarefas{carregado&&porFazer>0?` (${porFazer})`:''} {aberto?'▲':'▼'}
      </button>
      {aberto && (
        <div style={{ marginTop:8 }}>
          <div style={{ display:'flex', gap:6, marginBottom:8, flexWrap:'wrap' }}>
            <input value={texto} onChange={e=>setTexto(e.target.value)} onKeyDown={e=>{ if(e.key==='Enter') adicionar(); }} placeholder="Nova tarefa…"
              style={{ flex:1, minWidth:140, padding:'7px 10px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none' }}/>
            <select value={resp} onChange={e=>setResp(e.target.value)} title="Responsável pela tarefa"
              style={{ padding:'7px 10px', border:`1px solid ${resp&&resp!==autorEmail?C.purple:C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none', maxWidth:150, color:resp&&resp!==autorEmail?C.purple:C.text }}>
              {(!users||!users.some(u=>u.email===autorEmail))&&<option value={autorEmail}>{autorNome||autorEmail} (eu)</option>}
              {(users||[]).map(u=><option key={u.email} value={u.email}>{u.email===autorEmail?`${u.full_name||u.email} (eu)`:(u.full_name||u.email)}</option>)}
            </select>
            <input type="date" value={data} onChange={e=>setData(e.target.value)} title="Data de lembrete"
              style={{ padding:'7px 10px', border:`1px solid ${data?C.purple:C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", outline:'none', color:data?C.purple:C.textLight }}/>
            <button onClick={adicionar} disabled={saving} style={{ background:C.purple, border:'none', borderRadius:6, color:'#fff', padding:'7px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}>{saving?'...':'Adicionar'}</button>
          </div>
          {tarefas.length===0 ? <div style={{ fontSize:11, color:C.textLight, fontStyle:'italic' }}>Sem tarefas nesta fase.</div> :
           tarefas.map(t=>{
             const atrasada = t.data_lembrete && !t.feita && t.data_lembrete < hoje;
             const hojeMesmo = t.data_lembrete && !t.feita && t.data_lembrete === hoje;
             return (
             <div key={t.id} style={{ display:'flex', gap:8, alignItems:'flex-start', padding:'6px 0', borderBottom:`1px solid ${C.border}` }}>
               <input type="checkbox" checked={t.feita} onChange={()=>toggleFeita(t)} style={{ marginTop:2, cursor:'pointer' }}/>
               <div style={{ flex:1 }}>
                 <div style={{ fontSize:12, color:t.feita?C.textLight:C.text, textDecoration:t.feita?'line-through':'none' }}>{t.texto}</div>
                 <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                   {t.data_lembrete && <div style={{ fontSize:10, marginTop:2, fontWeight:600, color: t.feita?C.textLight : atrasada?'#C0392B' : hojeMesmo?'#F39C12' : C.textLight }}>📅 {fmtD(t.data_lembrete)}{atrasada?' · atrasada':hojeMesmo?' · hoje':''}</div>}
                   {t.responsavel_nome && <div style={{ fontSize:10, marginTop:2, fontWeight:600, color:C.purple }}>👤 {t.responsavel_nome}</div>}
                   {t.link && <a href={t.link} onClick={e=>e.stopPropagation()} style={{ fontSize:11, fontWeight:700, color:'#691FB1', textDecoration:'none' }}>{/ficha/.test(t.link) ? '🎓 Abrir a ficha →' : 'Abrir →'}</a>}
                 </div>
               </div>
               <button onClick={()=>apagar(t.id)} style={{ background:'none', border:'none', color:'#C0392B', fontSize:11, cursor:'pointer' }}>🗑</button>
             </div>
             );
           })}
        </div>
      )}
    </div>
  );
}


function MinhasTarefas({ userEmail, projects, onAbrirProjeto }) {
  const [tarefas, setTarefas] = useState([]);
  const [filtro, setFiltro] = useState('porfazer'); // porfazer | feitas | todas
  const [carregado, setCarregado] = useState(false);

  const nomeProj = {};
  (projects||[]).forEach(p => { nomeProj[p.id] = p.name; });

  const load = async () => {
    const { data } = await supabase.from('project_tarefas').select('*')
      .or(`responsavel_email.eq.${userEmail},and(responsavel_email.is.null,autor_email.eq.${userEmail})`)
      .order('data_lembrete', { ascending: true, nullsFirst: false });
    setTarefas(data || []); setCarregado(true);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [userEmail]);

  const toggleFeita = async (t) => {
    const agoraFeita = !t.feita;
    await supabase.from('project_tarefas').update({ feita: agoraFeita, feita_em: agoraFeita ? new Date().toISOString() : null }).eq('id', t.id);
    load();
  };

  const hoje = new Date().toISOString().slice(0,10);
  const fmtD = (d) => { try { return new Date(d+'T00:00:00').toLocaleDateString('pt-PT'); } catch { return d; } };
  const fmtDT = (d) => { try { return new Date(d).toLocaleDateString('pt-PT') + ' ' + new Date(d).toLocaleTimeString('pt-PT',{hour:'2-digit',minute:'2-digit'}); } catch { return d; } };

  const visiveis = tarefas.filter(t => filtro==='todas' ? true : filtro==='feitas' ? t.feita : !t.feita);
  const nPorFazer = tarefas.filter(t=>!t.feita).length;
  const nAtrasadas = tarefas.filter(t=>!t.feita && t.data_lembrete && t.data_lembrete < hoje).length;

  const btn = (v, lbl) => (
    <button onClick={()=>setFiltro(v)} style={{ background:filtro===v?C.purpleLight:'transparent', border:`1px solid ${filtro===v?C.purple:C.border}`, borderRadius:7, color:filtro===v?C.purple:C.textLight, padding:'6px 14px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:filtro===v?700:400 }}>{lbl}</button>
  );

  return (
    <div>
      <div style={{ display:'flex', gap:8, marginBottom:16, alignItems:'center', flexWrap:'wrap' }}>
        {btn('porfazer', `Por fazer${nPorFazer>0?` (${nPorFazer})`:''}`)}
        {btn('feitas', 'Feitas')}
        {btn('todas', 'Todas')}
        {nAtrasadas>0 && <span style={{ fontSize:12, color:'#C0392B', fontWeight:600, marginLeft:4 }}>{nAtrasadas} em atraso</span>}
      </div>
      {!carregado ? <div style={{ color:C.textLight, fontSize:13 }}>A carregar…</div> :
       visiveis.length===0 ? <div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:`1px solid ${C.border}` }}>{filtro==='porfazer'?'Não tens tarefas por fazer. 🎉':filtro==='feitas'?'Ainda não há tarefas feitas.':'Sem tarefas.'}</div> :
       <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
         {visiveis.map(t=>{
           const atrasada = t.data_lembrete && !t.feita && t.data_lembrete < hoje;
           const hojeMesmo = t.data_lembrete && !t.feita && t.data_lembrete === hoje;
           const proj = t.project_id && nomeProj[t.project_id] ? nomeProj[t.project_id] : null;
           return (
           <div key={t.id} style={{ display:'flex', gap:12, alignItems:'flex-start', background:C.white, border:`1px solid ${atrasada?'#F5C6C0':C.border}`, borderRadius:10, padding:'12px 16px' }}>
             <input type="checkbox" checked={t.feita} onChange={()=>toggleFeita(t)} style={{ marginTop:3, cursor:'pointer', width:16, height:16 }}/>
             <div style={{ flex:1 }}>
               <div style={{ fontSize:14, color:t.feita?C.textLight:C.text, textDecoration:t.feita?'line-through':'none', fontWeight:500 }}>{t.texto}</div>
               <div style={{ display:'flex', gap:12, marginTop:4, flexWrap:'wrap' }}>
                 {t.data_lembrete && <span style={{ fontSize:11, fontWeight:600, color: t.feita?C.textLight : atrasada?'#C0392B' : hojeMesmo?'#F39C12' : C.textLight }}>&#128197; {fmtD(t.data_lembrete)}{atrasada?' · em atraso':hojeMesmo?' · hoje':''}</span>}
                 {proj && <span onClick={()=>onAbrirProjeto&&onAbrirProjeto(t.project_id)} style={{ fontSize:11, color:C.purple, cursor:'pointer', fontWeight:600 }}>&#128193; {proj}</span>}
                 {t.autor_email && t.autor_email!==userEmail && <span style={{ fontSize:11, color:C.textLight }}>atribuída por {t.autor_nome||t.autor_email}</span>}
                 {t.feita && t.feita_em && <span style={{ fontSize:11, color:'#27AE60', fontWeight:600 }}>&#10003; Concluída {fmtDT(t.feita_em)}</span>}
                 {t.link && <a href={t.link} onClick={e=>e.stopPropagation()} style={{ fontSize:11, fontWeight:700, color:'#691FB1', textDecoration:'none' }}>{/ficha/.test(t.link) ? '🎓 Abrir a ficha →' : 'Abrir →'}</a>}
               </div>
             </div>
           </div>
           );
         })}
       </div>}
    </div>
  );
}
